{
  "USD": "USD",
  "GBP": "GBP",
  "EUR": "EUR",
  "AUD": "AUD",
  "general": {
    "login": "Login",
    "name": "Name",
    "email-address": "Email address",
    "full-name": "Full name",
    "failed": "Failed",
    "processing": "Processing",
    "app-loading": "App loading",
    "loading": "Loading",
    "team-members": "members",
    "spaces-available": "spaces available",
    "office-full": "Full",
    "AM": "AM",
    "PM": "PM",
    "am-only": "AM only",
    "pm-only": "PM only",
    "add": "Add",
    "desks-available": "Desks available",
    "successfully-logged-out": "Successfully logged out",
    "admin": "(Admin)",
    "no-team": "No team",
    "or": "Or",
    "no-department": "-- No department --",
    "select-department": "-- Select a department --",
    "all-teams": "All teams",
    "select-team": "-- Select a team --",
    "first-monday": "First Monday in",
    "first-day": "First day in",
    "how-it-works": "How it works",
    "description": "Description"
  },
  "errors": {
    "email-in-use": {
      "title": "That email address is in use.",
      "message": "If you have already registered but want to switch to Google or Microsoft contact <0>hello@team-today.com</0> and we can migrate your account"
    },
    "email-exists": {
      "message": "Try <0>logging in</0> or contact us at <1>hello@team-today.com</1> and we can help.",
      "logging-in": "logging in"
    },
    "company-already-registered": {
      "title": "Your company already has an account.",
      "message": "Speak to another user at your company for an invite. If you already have an account, try <0>logging in</0>.",
      "logging-in": "logging in"
    },
    "general": {
      "title": "There has been an error registering you.",
      "message": "Try again, if the problem persists contact <0>hello@team-today.com</0> and we can help."
    },
    "no-account-registered": {
      "title": "There has been an error registering you.",
      "message": "You can register for an account or ask a colleague for an invite. If you think you already have an account please contact <0>support@team-today.com</0>.",
      "button": "Register a new account"
    },
    "azure": {
      "consent-message": {
        "message-1": "In order for Team Today to work with <strong>Microsoft 365</strong> we need permission to securely access your <strong>calendar and mail settings</strong>.",
        "message-2": "Please ensure you tick the checkboxes for permissions and click accept."
      },
      "access-denied": {
        "message-1": "In order for Team Today to work with <strong>Microsoft 365</strong> we need permission to securely access your <strong>calendar and mail settings</strong>.",
        "message-2": "You can request access to team-today.com from <strong>your IT department</strong> or contact <a href=\"mailto:hello@team-today.com\">hello@team-today.com</a> for more advice and help."
      },
      "not-access-den-and-not-consent": {
        "message-1": "Something unexpected has happened.",
        "message-2": "We have logged the problem, you can try to log in again and if you're still having issues message us at <a href=\"mailto:hello@team-today.com\">hello@team-today.com</a> and we'll be in touch as soon as possible."
      }
    }
  },
  "login": {
    "title": "Log in to your account",
    "valid-email-address-error": "Please enter a valid email address",
    "enter-password": "Please enter a password",
    "signup-with-microsoft": "Secure sign up with",
    "sync-own-calendars": "to easily sync your calendars.",
    "with-google": "Log in with Google",
    "with-office365": "Log in with Microsoft 365",
    "or-login-with-email": "Or Log in with email",
    "email-address": "Email address",
    "password": "Password",
    "repeat-password": "Repeat password",
    "remember": "Remember me",
    "login": "Login",
    "no-account": "Don't have an account?",
    "have-an-account": "Already have an account?",
    "microsoft": "Microsoft",
    "microsoft-or-google": "Microsoft or Google",
    "email-sent": "We've sent you an email",
    "email-validated": "Your email was validated, now just login to Team Today to start using it.",
    "email-validation-failed": "Try requesting the validation email again.",
    "terms-link": {
      "1": "I agree to the",
      "2": "Terms & Conditions",
      "3": "and",
      "4": "Privacy Policy"
    },
    "marketing-emails": "Keep me up to date with the latest news and content from Team Today",
    "login-failed-with-azure": "Something went wrong getting your account from Microsoft, please try again.",
    "login-failed-with-azure-help": "If the problem persists, contact us at <0>hello@team-today.com</0> and we will help.",
    "create-account-with-own-password": "Create an account with your own password. This account will not sync with Microsoft 365 or Google.",
    "company-already-has-account": "Your company already has an account. You can proceed straight away with your Microsoft 365 login",
    "try-another-method": "Or click here to use another method",
    "not-registered": "The account {{email}} is not registered with Team Today.",
    "not-registered-no-email": "Your Microsoft account is not registered with Team Today.",
    "not-registered-help": "If your company already uses Team Today, ask a colleague or an IT administrator for an invite, otherwise register a new account.",
    "not-registered-assistance": "If you require assistance reach out to us at <0>hello@team-today.com</0>."
  },
  "register": {
    "title": "Sign up",
    "best-experience-signup": "For the best experience Sign Up securely with <strong>Microsoft</strong> or <strong>Google</strong> to easily sync Team Today to your work calendar.",
    "office365": "Sign up with Microsoft 365",
    "google": "Sign up with Google",
    "email": "Sign up with Email",
    "follow-the-link": "Follow the link to complete your registration.",
    "review-terms": "Review the terms to sign up",
    "terms-accept-message": "I agree to the <0>Terms & Conditions</0> and <1>Privacy Policy</1>*",
    "best-experience-use-ms": "For the best experience we recommend signing up securely with <strong>Microsoft</strong> to easily sync Team Today to your work calendar.",
    "create-account-with-password": "Create account with password",
    "register-tnc": "I agree to the <a href=\"https://team-today.com/legal/terms-and-conditions\">Terms & Conditions</a> and <a href=\"https://team-today.com/legal/privacy-policy\">Privacy Policy</a>*",
    "verification-required": "We need to verify your email",
    "check-inbox": "Check your inbox",
    "follow-link": "Follow the link to complete your registration",
    "resend-email": "Resend email?"
  },
  "teams-register": {
    "title": "The Simplest Way to <strong>Manage\n and Plan Hybrid</strong> Working",
    "create-account": "Or <0>create an account with email</0> and password",
    "have-account": "Already have an account? <0>Log in</0>",
    "list-item-1": "Manage <strong>Team Whereabouts</strong>",
    "list-item-2": "Book <strong>desks</strong> and manage <strong>offices</strong>",
    "list-item-3": "Plan leave and <strong>holidays</strong>",
    "started": "Get Started For Free",
    "": ""
  },
  "forgot-password": {
    "forgot-password": "Forgot password",
    "description": "Enter your email address and we’ll send you a link to create a new password",
    "send-password": "Send password reset",
    "request-processing": "Your password reset request is being processed.",
    "follow-link": "Follow the link to reset your password.",
    "enter-email-address": "Enter your email address and we’ll send you a link to create a new password",
    "send-password-reset": "Send password reset",
    "your-email-address": "Your email address"
  },
  "reset-password": {
    "stale-token": "That token has expired. Request a new email",
    "success": "Success! Go to the login page to sign-in",
    "forgot-password": "Forgot password",
    "go-to-login": "Go to login",
    "try-requesting-new-email-reset": "Try requesting a new email reset",
    "request-new-email-reset": "Request a new reset email",
    "new-pass": "New password",
    "repeat-new-pass": "Repeat new password",
    "reset-pass": "Reset password",
    "reset-pass-to-login": "Reset your password to enable you to login",
    "passwords-not-match": "Passwords do not match",
    "passwords-not-blank": "Password must not be blank"
  },
  "invite": {
    "title": "Complete registration",
    "passwords-mismatch": "Passwords do not match",
    "failed": "Passwords do not match",
    "register-failed": "Register with invite failed",
    "tandc": "Please accept the Terms and Conditions before progressing.",
    "issues": "Still having issues? Email us at <a href=\"mailto:hello@team-today.com\">hello@team-today.com</a> and we’ll get back to you ASAP.",
    "create-account-with-password": "Or <0>create an account with password</0>"
  },
  "team-view": {
    "team-view": "Team View",
    "whereabouts-report": "My Whereabouts Report",
    "whereabouts": "Whereabouts",
    "edit-whereabouts": "Edit whereabouts",
    "set-whereabouts": "Set whereabouts",
    "teams": "Teams",
    "offices": "Offices",
    "workgroup": "Work group",
    "departments": "Departments",
    "misc": "Misc"
  },
  "settings": {
    "settings": "Settings",
    "bookable-areas": "Bookable areas",
    "desk-booking": "Desk Booking",
    "office-information": "Office Information",
    "office-information-how-it-works": "Offices appear for users to book in Team Whereabouts. You can assign users to an office so that this will be there default location.",
    "desk-bookings-how-it-works": "Offices appear for users to book in Team Whereabouts. You can assign users to an office so that this will be there default location.",
    "button-add-team-member": "Add New Team Member",
    "button-add-user": "Add a user",
    "edit-office": "Edit office",
    "create-new-office": "Create new office",
    "edit-past-whereabouts-title": "Block users editing past whereabouts",
    "edit-past-whereabouts-enabled-description": "This setting allows only company admins and office admins to edit previous weeks whereabouts.",
    "edit-past-whereabouts-disabled-description": "Users can edit their past whereabouts",
    "edit-past-whereabouts-recommendation": "We recommend turning this on if approvals is enabled or Team Today is being used to monitor absence.",
    "manage-teams-and-users": "Manage teams and users",
    "users-with-no-teams": "Users with no team",
    "my-team": "My team",
    "other-teams": "Other teams",
    "personal-pref": "Personal preferences",
    "personal-pref-desc": "Set reminders and sync your Team Today events to your personal calendar",
    "email-reminder": "Email reminder",
    "email-reminder-desc": "Receive a weekly email reminder to set your whereabouts for the upcoming week.",
    "calendar-link": "Add events to your work calendar",
    "languages": "Change Language",
    "calendar-link-tip": "For the best experience we recommend you keep this setting on.",
    "calendar-link-desc": "Add events such as holidays and whereabouts from Team Today to your <strong>Outlook</strong> or <strong>Gmail</strong> calendars for team mates to see. ",
    "marketing-emails": "Allow marketing emails",
    "marketing-emails-desc": "Receive email announcing our latest features and how to use them.",
    "teams-test": "Test Teams notifications",
    "teams-test-desc": "Send yourself a message from the Team Today app in Microsoft Teams to check notifications reach you. You can send one an hour.",
    "teams-test-button": "Send test",
    "teams-test-sent": "Sent. Look for it in your Team Today chat in Teams. You can send another at {{time}}.",
    "teams-test-too-soon": "You can send one test an hour. Try again at {{time}}.",
    "teams-test-no-chat": "Team Today can't message you in Teams yet. Add the Team Today app in Teams, or if you have it, send it any message in its chat. Then try again.",
    "teams-test-disabled": "Teams notifications are switched off for your account. Email support@team-today.com to switch them back on.",
    "teams-test-failed": "Teams didn't accept the message. Try again later.",
    "teams-test-error": "Couldn't send the test. Try again.",
    "fav-office": "Your favourite offices",
    "assigned-desk": "Assigned",
    "billing-header": "Billing and plan settings",
    "payment-details": "Payment details",
    "cancel-message": "Your payment details are managed by an account manager, to update or change them contact us at <strong><0>support@team-today.com</0></strong>",
    "account-usage": "Manage your subscription plan, licences, and billing information.",
    "users-registered": "Users registered",
    "spaces-left": "Spaces left",
    "teams-in-use": "Teams in use",
    "car-parking": "Car parking",
    "car-parking-how-it-works": "Offices car park, contact us to manage car park spaces with an interactive map.",
    "automatic-checkin": "Automatic Check-in",
    "teams-left": "Teams left",
    "member-limit-reached": "Your account is now full",
    "account-full-in-teams": "This account is now full, please contact us at support@team-today.com",
    "account-full-normal": "Your <strong>free account</strong> is now <strong>full</strong>. To add anymore team members you will need to upgrade to a paid account.",
    "holiday-rules": "Finish holiday rules",
    "holiday-year-start-message": "Let us know when your leave year starts.",
    "all-users-have-team": "All users have a team!",
    "setup-a-company": "Setup a company",
    "company-name": "Company Name",
    "create-floor-plan": "Create a floor plan",
    "create-floor-plan-description": "With a floor plan you can book specific desks and see where team mates are sat ",
    "create-floor-plan-instructions": "Send your floor plan to <0 href=\"mailto:hello@team-today.com\">hello@team-today.com</0> and we’ll create an interactive version of it for your team to use... for FREE",
    "users-reporting-to-this-user": "These are all of the people that report directly to this user.",
    "line-reports": "Line reports",
    "indirect-line-reports": "Indirect line reports",
    "no-line-reports": "No line reports",
    "office-management": "Office management",
    "set-limits-on-offices": "Set a limit to the number of office desks available so colleagues know when to come into the office.",
    "offices": "Offices",
    "office-floor": "Office floor",
    "manage-office-locations-title": "Manage office locations",
    "manage-office-locations-description": "Create and manage multiple offices in the office management area.",
    "assign-users": "Assign Users",
    "users-not-in-team": "These users are not currently in a team. Tap on one to move them to a team.",
    "locked-signup-domains": {
      "title": "Locked domains",
      "subtitle": "Stop people at your company from creating a separate Team Today account. Anyone signing up with one of these domains will be told your company already has an account and to ask a colleague for an invite. Invited users can still join as normal.",
      "approval-note": "New domains are checked by the Team Today team before they take effect. This usually happens within one working day.",
      "placeholder": "e.g. yourcompany.com",
      "add": "Add domain",
      "remove": "Remove",
      "empty": "No domains added yet.",
      "status-active": "Active",
      "status-pending": "Pending approval",
      "status-rejected": "Not approved",
      "rejected-help": "We could not confirm your company owns this domain. Contact support@team-today.com if you think this is a mistake.",
      "remove-confirm": "Remove {{domain}}? People with this email domain will be able to create a new account again.",
      "add-failed": "Could not add that domain.",
      "remove-failed": "Could not remove that domain."
    },
    "domain-based-signup": {
      "title": "Link domain name",
      "subtitle": "Individuals can sign up themselves",
      "everyone": "Good for everyone",
      "enabled-message": "Anyone who signs up with an email address that ends in <0>{{domainName}}</0> will be immediately added to your account. Simply let them know about Team Today and ask them to create an account.",
      "enabled-message-multiple": "Anyone who signs up with an email address that ends in one of <0>{{domains}}</0> will be immediately added to your account. Simply let them know about Team Today and ask them to create an account.",
      "disabled-message": "Anyone who signs up with an email address that ends in <0>your domain name<0> will be immediately added to your account. Simply let them know about Team Today and ask them to create an account.",
      "your-domain-name": "your domain name",
      "domains-title": "Linked domains",
      "approval-note": "Add every email domain your company uses. Each one is checked by the Team Today team before it takes effect, usually within one working day.",
      "placeholder": "e.g. yourcompany.com",
      "add": "Add domain",
      "remove": "Remove",
      "empty": "No domains linked yet. Add your company's email domain to get started.",
      "status-active": "Active",
      "status-pending": "Pending approval",
      "status-rejected": "Not approved",
      "rejected-help": "We could not confirm your company owns this domain. Contact support@team-today.com if you think this is a mistake.",
      "remove-confirm": "Remove {{domain}}? People with this email domain will no longer join your account automatically.",
      "add-failed": "Could not add that domain.",
      "remove-failed": "Could not remove that domain.",
      "switch-off-note": "Turn on the switch above for these domains to take effect.",
      "pending-line-1": "Please allow 24 hours for this setting",
      "pending-line-2": "As part of our security process we actively review linkage requests.",
      "pending-line-3": "Once approved, new users who have not been invited will need assigning to a team. You can do this user settings.",
      "pending-line-4": "You will still be able to send direct invites to email addresses that do not end in this domain name.",
      "active-line-1": "Just so you know",
      "active-line-2": "New users who have not been invited will need assigning to a team. You can do this user settings.",
      "active-line-3": "You will still be able to send direct invites to email addresses that do not end in this domain name."
    },
    "calendar-sync": {
      "title": "Calendar sync",
      "subtitle": "Allow users to sync their whereabouts to their Outlook or Google calendar. Each user must also turn on calendar sync in their own profile settings."
    },
    "private-groups": {
      "title": "Restrict visibility of all groups",
      "subtitle": "Restrict the visibility of all departments, teams and groups are restricted. Only Company & Office admins as well as users in the groups will be able to view other users whereabouts."
    },
    "schengen": {
      "title": "Schengen Tracking",
      "subtitle": "Track the number of days people spend in the the Schengen area"
    },
    "mcp-integration": {
      "title": "MCP integration",
      "subtitle": "Allow AI assistants to securely connect to TeamToday via the Model Context Protocol, by signing in or with a company API key. When disabled, MCP tool requests are rejected.",
      "approved-apps": {
        "title": "Approved apps",
        "note": "Claude and apps on people's own computers, such as Claude Code, can always connect. Any other app needs a company admin to approve it, which they do the first time they connect it themselves. Removing an app disconnects everyone using it within a few minutes.",
        "empty": "No other apps have been approved.",
        "calls-itself": "Calls itself \u201c{{name}}\u201d",
        "approved-on": "Approved {{date}}",
        "remove": "Remove",
        "remove-confirm": "Remove {{host}}? Everyone in your company who has connected it will be disconnected, and it will need approving again before anyone can reconnect it.",
        "remove-failed": "Could not remove this app. Please try again."
      }
    },
    "signage": {
      "title": "Enable Waypoint screens",
      "subtitle": "Show a live floor plan of who's in the office today on a wall-mounted screen. Pair screens with an admin-approved code, just like the visitor check-in kiosk.",
      "upsell": "Waypoint screens are available on the Premium and Enterprise plans.",
      "upsell-link": "Upgrade your plan",
      "not-enabled": "This feature is not enabled on your account. Contact",
      "manage-link": "Set up screens and display options in Waypoint screens",
      "name-display": {
        "title": "Name display",
        "subtitle": "How people are labelled on the screen. Applied by the server, so screens never receive more than this.",
        "full-names": "Full names",
        "initials": "Initials only",
        "reserved-only": "Reserved only"
      },
      "safety-roles": {
        "title": "Show first aiders and fire wardens",
        "subtitle": "A strip listing today's in-office first aiders and fire wardens. Always shows full names, in every name display mode; switch it off if that's not appropriate for your office."
      }
    },
    "lockers": {
      "title": "Enable lockers",
      "subtitle": "Keep a directory of the lockers in each office, assign them to colleagues, and let people join a waiting list when none are free.",
      "upsell": "Lockers are available on the Premium and Enterprise plans.",
      "upsell-link": "Upgrade your plan",
      "not-enabled": "This feature is not enabled on your account. Contact"
    },
    "training": {
      "title": "Enable training",
      "subtitle": "Keep a register of the training people have completed, when each one runs out, and who is overdue.",
      "upsell": "Training is available on the Premium and Enterprise plans.",
      "upsell-link": "Upgrade your plan",
      "not-enabled": "This feature is not enabled on your account. Contact"
    },
    "whereabouts-reminder-config": {
      "title": "Whereabouts reminder settings",
      "subtitle": "Send weekly reminders to users in Microsoft Teams to set their Whereabouts.",
      "day": "Day to send reminder",
      "day-placeholder": "Day to send",
      "hour": "Hour to send reminder",
      "hour-placeholder": "Hour to send",
      "timezone": "Timezone",
      "timezone-placeholder": "Timezone",
      "enable": "Enable"
    },
    "restrict-team-management": {
      "title": "Restrict team management",
      "subtitle": "Restrict the management of teams to Company Admins. This includes adding new users, as well as moving or removing existing users."
    },
    "show-birthdays": {
      "title": "Show birthdays",
      "subtitle": "If a user has set the month and day of their birthday this will show users birthdays as a small icon on their whereabouts."
    },
    "leave-digest": {
      "title": "Weekly leave and absence summary",
      "subtitle": "Sends a regular email summarising upcoming leave and absences so the right people can plan around them.",
      "schedule-note": "Sent on a Monday it covers that week and the next. Sent on any other day it covers the following two weeks.",
      "recipients": {
        "label": "Who should receive the digest?",
        "placeholder": "Select recipients",
        "line-managers": "Line managers (for their line reports)",
        "team-admins": "Team admins (for their team members)",
        "all-team-members": "All team members (for their fellow team members)"
      }
    },
    "missing-whereabouts": {
      "title": "Weekly missing whereabouts report",
      "subtitle": "Emails a list of people who have not set their whereabouts for the following week and how many days each is missing.",
      "schedule-note": "It always covers the week starting on the Monday after it is sent.",
      "recipients": {
        "label": "Who should receive it?",
        "placeholder": "Select recipients",
        "company-admins": "Company admins (for everyone in the company)",
        "team-admins": "Team admins (for their team members)",
        "line-managers": "Line managers (for their line reports)"
      }
    },
    "whereabouts-summary": {
      "title": "Monthly whereabouts summary",
      "subtitle": "Emails a monthly summary of where the company worked, sent on the first of each month.",
      "recipients": {
        "label": "Who should receive it?",
        "placeholder": "Select recipients",
        "company-admins": "All company admins",
        "team-admins": "All team admins",
        "line-managers": "All line managers"
      }
    },
    "office-summary": {
      "title": "Monthly office summary",
      "subtitle": "Emails a monthly per-office attendance summary, sent on the first of each month.",
      "recipients": {
        "label": "Who should receive it?",
        "company-admins": "All company admins",
        "office-admins": "All office admins"
      }
    },
    "visitor-summary": {
      "title": "Weekly visitor summary",
      "subtitle": "Emails a summary of the visitors booked in for the coming week.",
      "schedule-note": "It always covers the week starting on the Monday after it is sent.",
      "recipients": {
        "label": "Who should receive it?",
        "company-admins": "All company admins",
        "office-admins": "All office admins"
      }
    },
    "reports-schedule": {
      "label": "When should it be sent?",
      "description": "Choose the day and time this report is emailed each week.",
      "day": "Send on",
      "time": "at",
      "timezone": "Timezone"
    },
    "absence-reports": {
      "title": "Absence reports",
      "subtitle": "Email chosen people a list of everyone in one or more departments who is not in work: leave, sickness, training, non-working days and other absences. Create as many reports as you need, each sent daily, weekly or monthly. Nothing is sent when nobody is off.",
      "empty": "No absence reports yet.",
      "add": "New absence report",
      "new-title": "New absence report",
      "edit-title": "Edit absence report",
      "name-placeholder": "For example, Sales daily absences",
      "frequency": "How often",
      "daily": "Daily",
      "weekly": "Weekly",
      "monthly": "Monthly",
      "schedule-daily": "Sent Monday to Friday, listing who is not in work that day.",
      "schedule-weekly": "Sent on the day you choose, covering the coming Monday to Sunday.",
      "schedule-monthly": "Sent on the 1st of each month, covering that month.",
      "recipients-help": "Company admins see private absence types. Everyone else sees them as a non-working day.",
      "remove-recipient": "Remove {{name}}",
      "enabled": "Send this report",
      "paused": "Paused",
      "summary-daily": "Weekdays at {{time}}",
      "summary-weekly": "Every {{day}} at {{time}}",
      "summary-monthly": "1st of each month at {{time}}",
      "summary-and": "and",
      "summary-more": "{{count}} more",
      "summary-none": "None",
      "label-when": "When",
      "label-name": "Name",
      "label-schedule": "Schedule",
      "label-send-to": "Send to",
      "label-departments": "Departments",
      "label-recipients": "Sent to",
      "save": "Save report",
      "cancel": "Cancel",
      "edit": "Edit",
      "delete": "Delete",
      "delete-confirm": "Delete the report \"{{name}}\"? This cannot be undone.",
      "save-failed": "Couldn't save the report, please try again.",
      "delete-failed": "Couldn't delete the report, please try again.",
      "missing-fields": "Add a name, at least one department and at least one person to send it to."
    },
    "reports-sample": {
      "button": "Send me a sample",
      "success": "Sample report sent — check your inbox.",
      "failure": "Couldn't send the sample report, please try again shortly.",
      "cooldown": "Available again in {{minutes}} min"
    },
    "azure-scim": {
      "medium": "Medium - Large companies (50 plus)",
      "title": "Microsoft Azure and Team Today",
      "scim-integration": "SCIM Integration Settings",
      "scim-endpoint": "SCIM endpoint",
      "scim-endpoint-description": "Enter this as the Tenant URL when setting up provisioning in Microsoft Entra ID, and use a SCIM API key as the Secret Token.",
      "subtitle": "Import users from active directory to Team Today",
      "description": "IT Admins can look up Team Today in the Microsoft Azure marketplace. This will automate leavers and starters into Team Today from Active Directory and place them into teams, workgroups or departments. Detailed instructions can be found on our support pages.",
      "line-1": "Just so you know",
      "line-2": "With this enabled newly provisioned users will receive a welcome email and will be reminded each week to set their whereabouts.",
      "line-3": "More information on how to configure this can be found at <0 href=\"https://www.team-today.com\">SCIM Configuration</0>",
      "enabled-departments": "Restrict manual allocation of users to departments",
      "enabled-departments-description": "When enabled, users cannot be manually added to a department within Team Today.",
      "enabled-departments-description-2": "Good to enable if your users are provisioned into departments via SCIM, as department membership will be managed automatically.",
      "disable-welcome-email": "Send welcome email to newly provisioned users",
      "disable-welcome-email-description": "Once initial Azure setup and testing has been completed we recommend enabling this setting to send welcome emails to new users.",
      "disable-new-user-access": "Allow newly provisioned users access to Team Today",
      "disable-new-user-access-description": "Once initial Azure setup and testing has been completed we recommend enabling this setting to grant new users access to Team Today."
    },
    "spreadsheet": {
      "trial": "Companies on a free trial",
      "title": "Import a spreadsheet",
      "subtitle": "If you don’t want to connect Azure just yet or are smaller than 50 people",
      "description": "Contact support@team-today and we’ll supply a template for you to complete, then send back and we’ll do the rest."
    },
    "holiday-approval": {
      "title": "Approval notifications",
      "message": "This will send relevant line managers an email when a holiday is booked prompting them to go to Team Today to review a holiday request."
    },
    "holiday-tracking": {
      "title": "Enable holiday tracking",
      "message": "This will enable the holiday tracking setting so colleagues can quickly see when people have leave planned across their team and others."
    },
    "line-management": {
      "title": "Enable line managers",
      "enabled-message": "This will enable you to assign line reports to users. These managers will be able to approve requests made by their line reports. Go to <0 to={\"/manage/users?view=user\"}>User view</0> to search for users and assign them line reports.",
      "disabled-message": "This will enable the line managers setting so you can assign line reports to users. These managers will be able to approve requests made by their line reports."
    },
    "seven-day": {
      "title": "Enable seven day week",
      "enabled-message": "This will allow users to complete whereabouts on weekends.",
      "disabled-message": "This will allow users to complete whereabouts on weekends."
    },
    "weekly-notes": {
      "title": "Enable weekly notes",
      "enabled-message": "Weekly note enabled, users can set this from the team whereabouts page.",
      "disabled-message": "This will enable weekly notes - a free text field that users can fill out a short description that colleagues can see about their week."
    },
    "global-email-setting": {
      "title": "Email reminders to complete whereabouts",
      "all-users": "Reminders sent to all users weekly if incomplete",
      "no-users": "Don’t send any reminders",
      "users-choice": "Allow individuals to control their own reminders",
      "description": "Choose how reminders are sent. Reminders are sent if a user hasn’t completed the upcoming weeks whereabouts."
    },
    "icon-pack": {
      "title": "Team Today iconography",
      "description": "You can change the look and style of the icons used throughout Team Today",
      "standard": "Standard",
      "basic": "Professional"
    },
    "tenant-based": {
      "title": "Tenant based signup",
      "message-1": "This will associate your Microsoft Tenant ID with this account. Anyone who registers or will automatically be added to this account.",
      "message-2": "You will still be able to manually invite people from outside of your Microsoft account to join you.",
      "active-1": "Just so you know",
      "active-2": "New users who have not been invited will need assigning to a team. You can do this user settings.",
      "active-3": "You will still be able to send direct invites to email addresses that do not end in this domain name."
    },
    "hot-desking-page": {
      "title": "Advance hot desking",
      "message-1": "As part of a paid plan you can",
      "message-2": "Create multiple offices",
      "message-3": "Create floors and office areas for teams to book",
      "message-4": "Link it all to your Outlook or Gmail calendars",
      "button": "Turn on advanced hot desking"
    },
    "editing-future-whereabouts": {
      "repeat-weekly-schedule": "Whereabouts schedules",
      "repeat-weekly-schedule-description": "How many weeks into the future can a user automatically set their whereabouts for. We recommend 52 weeks.",
      "schedules": "Allow users to automatically set the next several weeks whereabouts at the same time",
      "number-of-weeks": "Advance whereabouts limit (in weeks)",
      "applies-to-team-admins": "Applies to team admins",
      "applies-to-standard-users": "Applies to standard users",
      "number-of-weeks-description": "The number of weeks users are able to set whereabouts in advance"
    },
    "approvals": {
      "title": "Approvals",
      "do-holidays-require-approval": "Do holidays require approval off a line manage or company admin?",
      "how-it-works": "How it works",
      "create-line-managers-message-1": "Create line managers by adding direct reports for each user in an individuals settings page. (Tap the user you want to edit)",
      "create-line-managers-message-2": "Then when reports book holidays or vacation the line manager will be asked to approve the request.",
      "create-line-managers-message-3": "Company admins can approve all requests.",
      "please-note": "Please note",
      "please-note-message-1": "At the moment only <strong>company admins</strong> can approve or reject holiday requests.",
      "company-admins": "company admins",
      "please-note-message-2": "Line managers can also do this but you need to enable the 'Line managers' setting in the company settings page and then assign line reports to each user.",
      "approvals-disabled-title": "Leave Approvals Inactive",
      "approvals-disabled-description": "You can turn on leave approvals for managers in the main settings area."
    },
    "holiday-allowance": {
      "title": "Holiday allowance",
      "message-1": "Set a limit to how many days each person can book off.",
      "please-note": "Please note",
      "message-2": "Users will all have {{defaultHolidayCount}} holidays until they are set by a company admin or line manager in each users' settings page.",
      "zero": "zero",
      "edit-individual-allowances": "Edit Individual Holiday Allowances"
    },
    "carry-over": {
      "title": "Enable auto carry over",
      "description": "Automatically carries holiday over from the previous year",
      "carry-over-days": "Maximum carry over",
      "rules-title": "Add expiry rules",
      "rules-description": "Set a rule to ensure carried-over days are used before a set date",
      "expires-on": "Carry over expires on"
    },
    "holiday-setting": {
      "year": "Leave Year",
      "month": "The time of the year your leave period starts and ends."
    },
    "manage-area": {
      "create-area": "Create bookable area",
      "name": "Area name",
      "message-1": "This will create spaces that multiple users can book into.",
      "message-2": "Makes desk booking faster",
      "number-of-desks": "Number of desks"
    },
    "manage-desk": {
      "create-desk": "Create individual bookable desks",
      "message-1": "Best used for individuals who always sit in the same desk",
      "message-2": "",
      "number-of-desks": "Number of desks",
      "floor-plans-enabled": "Looks like you have interactive floor plans enabled",
      "contact-us-to-change": "You can still add a new desk to the floor but contact us at <0 href=\"mailto:hello@team-today.com\">hello@team-today.com</0> to add it to the interactive floor plan.",
      "desk-name": "Desk name"
    },
    "manage-hospitality": {
      "title": "Manage hospitality",
      "enable-hospitality": "Enable hospitality",
      "add-new-item": "Add hospitality item",
      "add-people-to-notify": "Add people to notify",
      "important-note": "No important note set",
      "important-note-title": "Important hospitality notes (visible to employees)",
      "notifications": "Notifications",
      "add-people-message": "Add people (e.g., Office Assistants) to notify when a hospitality request is submitted.",
      "number-of-people-notifying": "Notifying {{count}} people.",
      "hospitality-description": "Add items (e.g., catering) that employees can request for meeting rooms.",
      "menu-item": "Menu item",
      "availability": "Availability",
      "item-name": "Item name",
      "notes": "Notes",
      "price": "Price",
      "currency": "Currency",
      "add-hospitality-item": "Add hospitality item",
      "edit-important-note": "Edit important note"
    },
    "visitor-booking": {
      "title": "Enable visitor booking",
      "heading": "Visitor Management",
      "upsell": "Visitor booking is available on the Premium and Enterprise plans.",
      "upsell-link": "Upgrade your plan",
      "not-enabled": "This feature is not enabled on your account. Contact"
    },
    "manage-office": {
      "title": "Create office floor?",
      "message": "Split your office into floors to help your colleagues know where to sit",
      "another-floor": "Add another floor",
      "additional-access-required": "Additional access required",
      "company-admin-only": "Only a company admin is able to create new offices/floors/areas/desks",
      "nosetup": "You have nothing setup yet, start off by adding an office.",
      "no-setup-message-1": "Create <strong>floors</strong> and <strong>office areas</strong> for teams to book",
      "no-setup-message-2": "Create multiple offices",
      "no-setup-message-3": "Link it all to your <strong>Outlook</strong> or <strong>Gmail calendars</strong>",
      "enable-car-parking": "Enable car park booking",
      "car-parking-capacity": "Number of car park spaces",
      "desk-booking-window-title": "Enable desk booking window",
      "desk-booking-window-description": "Prevent users block booking desks too far in advance",
      "desk-booking-window-weeks": "Number of weeks users can book in advance",
      "desk-booking-window-opens-description": "Choose when the next week of bookings opens. The whole week opens at this moment.",
      "desk-booking-window-open-day": "Opens on",
      "desk-booking-window-open-time": "Opens at",
      "desk-booking-window-timezone": "Timezone",
      "desk-booking-window-unit": "Count the window in",
      "desk-booking-window-unit-weeks": "Weeks",
      "desk-booking-window-unit-days": "Days",
      "desk-booking-window-unit-workdays": "Working days (Mon to Fri)",
      "desk-booking-window-days": "Number of days users can book in advance",
      "desk-booking-window-workdays": "Number of working days users can book in advance",
      "desk-booking-window-opens-daily-description": "Choose the time each day when the next day opens.",
      "desk-booking-window-max-days": "The booking window can be at most {{max}} days"
    },
    "meeting-rooms": {
      "manage-meeting-rooms": "Manage meeting rooms",
      "add-meeting-rooms": "Add meeting rooms",
      "create": "Add a meeting room",
      "meeting-room": "meeting room",
      "name": "Meeting room name",
      "meeting-room-email-address": "Outlook meeting room email address",
      "important": "Important",
      "important-message": "Users will need to have their calendar sync active so rooms can be reserved in Outlook as well as Team Today. This status will display as green on the Team View.",
      "capacity": "Capacity",
      "office": "Office",
      "floor": "Floor",
      "edit": "Edit meeting room",
      "limit-title": "Meeting room limited reached",
      "limit-description": "Contact us at <0 href=\"mailto:support@team-today.com\">support@team-today.com</0> to increase your limit",
      "microsoft-link": "Link this room with a meeting room in Outlook",
      "microsoft-link-description": "You can link the room with a room in Outlook by using the rooms email address. Doing this will require users to have calendar permissions enabled so the room can be reserved in outlook as well as Team Today",
      "introduction": {
        "how": "How it works",
        "intro": "Add a meeting room in Team Today rather than Outlook or Google to enable:",
        "intro-1": "Team members to easily find all meeting rooms in one place",
        "intro-2": "Quickly check availability and book rooms",
        "intro-3": "Book meeting rooms on an interactive floor plan (if a floor plan has been added)"
      }
    },
    "looking-after-multiple-teams": "Looking after multiple teams?",
    "create-a-company": "Create a company view to see all your teams in one place",
    "departments": {
      "title": "Manage Departments",
      "add-new": "Add new department",
      "add-members": "Add new members"
    },
    "notify-manager-on-leave-cancellation": {
      "title": "Cancellation notifications",
      "subtitle": "When enabled, a user's line manager is emailed when the user cancels their own approved leave (holiday or any approval-required leave type)."
    }
  },
  "edit-workgroup": {
    "edit-workgroup": "Manage workgroup",
    "edit-workgroup-name": "Edit workgroup name",
    "add-or-remove-members": "Add or remove members",
    "add-users-to-group": "Add users to group",
    "select-users-to-add": "Select users to add"
  },
  "week-notes": {
    "week-notes": "Week notes",
    "my-note": "My note",
    "no-note-set": "No note set",
    "no-notes-for-team": "No notes set for the team",
    "week-of": "Week of {{date}}",
    "set-my-note": "Set my week note",
    "enter-your-note": "Enter your note for this week...",
    "must-be-in-team": "You must be in a team to set a week note",
    "save-failed": "Failed to save week note. Please try again."
  },
  "personal-perf": {
    "personal-perf": "Personal preferences",
    "office-perf": "Office preferences",
    "other-perf": "Other preferences",
    "default-office-and-location": "Default office and location",
    "default-office-title": "Your default office and location",
    "default-office-description": "Setting a default office makes setting whereabouts quicker. You can still pick any other office to visit.",
    "require-space-title": "Require parking space",
    "require-space-description": "Turn this setting on if you regularly require a parking space when visiting the office",
    "veh-registration": "Vehicle registration",
    "veh-colour": "Vehicle colour",
    "veh-make": "Vehicle make",
    "office-tab": "Office",
    "notifications-tab": "Notifications",
    "calendar-tab": "Calendar sync",
    "birthday-tab": "Birthday",
    "language-tab": "Language"
  },
  "approvals": {
    "approvals-title": "Approvals",
    "approved": "Approved",
    "cancelled": "Cancelled",
    "days": "days",
    "declined": "Declined",
    "holiday-approvals": "Approvals",
    "no-results-found": "No results found",
    "no-approvals-found": "No approvals found"
  },
  "work-planner": {
    "work-planner": "Work Planner",
    "show-other-teams": "Show other teams",
    "events-and-projects": "Projects / Events",
    "add-event-project": "Add Project / Event",
    "create-event-title": "Give your project / event a title",
    "event-is-for": "Event / project is for",
    "select-teams-to-follow": "Select teams to follow",
    "select-teams-to-follow-description": "You can follow three teams plus your own.",
    "select-teams-to-follow-error": "You first need unfollow a team before you can follow another.",
    "schengen-days-left": "{{days}} days left",
    "schengen-days-left-title": "Schengen days left",
    "schengen-days-left-explanation": "{{used}} of {{allowance}} days used by {{date}}, counted over the 180 days before that date."
  },
  "textinput": {
    "from": "From",
    "date": "Date",
    "to": "To",
    "firstname": "First name",
    "lastname": "Last name",
    "office-location": "Office location (optional)",
    "jobTitle": "Job Title",
    "email": "Email",
    "password": "Password",
    "repeat-password": "Repeat Password",
    "office-name": "Office name",
    "office-postcode": "Office postcode",
    "desks-available": "Desks available",
    "number-desks-available": "Number of desks available",
    "number-desks-for-floor": "Set number of desks for floor",
    "desks-available-each-day": "desks available each day",
    "floor-name": "Floor name",
    "add-individual-desks": "Add individual desks",
    "areas-names-and-avail": "Area names and availability",
    "desk-names-and-avail": "Desk names and availability",
    "search-existing-user": "Search for an existing user",
    "whereabouts-name": "Whereabouts name",
    "holiday-title-or-reason": "Holiday title or reason",
    "company-settings": "Company name",
    "team-name": "Team name",
    "enable-desk-booking": "Enable desk booking",
    "enable-car-parking": "Enable car parking",
    "add-date": "Add date",
    "select-placeholder": "Select...",
    "search": "Search",
    "select-start-day": "Select a start day",
    "find-user": "Find user",
    "mac-address-placeholder": "e.g. AA:BB:CC:DD:EE:FF",
    "network-name-placeholder": "e.g. Office-WiFi",
    "ip-address-placeholder": "e.g. 203.0.113.10",
    "select-desk": "Select a desk",
    "none-available": "None available",
    "select-month": "Select a month",
    "choose-an-office": "Choose an office",
    "filter-users": "Filter users",
    "please-select": "Please select",
    "select-team": "Select team",
    "office-three-letter-code": "Office 3 letter code"
  },
  "button": {
    "add-new-space": "Add new space",
    "filters": "Filters",
    "setup-offices": "Set up offices",
    "change-office": "Change office",
    "choose-day": "Choose a day",
    "show-more": "Show more",
    "show-less": "Show less",
    "save-changes": "Save changes",
    "back-and-change": "Go back and change",
    "view-whereabouts-report": "View My Whereabouts Report",
    "continue": "Continue",
    "done": "Done",
    "update": "Update",
    "edit": "Edit",
    "reset-to-current-week": "Reset to current week",
    "view-floor-plan": "View floor plan",
    "your-holidays": "Leave Planner",
    "requests": "Approvals",
    "team-holidays": "Team holidays",
    "approvals-required": "Approvals Required",
    "view-approvals": "Approvals",
    "team-view": "Team View",
    "back-to-team-view": "Back to team view",
    "settings": "Settings",
    "company-view": "Company View",
    "my-requests": "My requests",
    "work-planner": "Work Planner",
    "my-holiday-requests": "My holiday requests",
    "holiday-requests": "Holiday Requests",
    "office-view": "Office View",
    "all-teams": "All teams",
    "floor-plan": "Floor Plan",
    "yes": "Yes",
    "create-new-work-group": "Create a new work group",
    "create-new-team": "Create a new team",
    "create-new-group": "Create a new group",
    "create-new-department": "Create a new department",
    "link-team-or-workgroup": "Link Team or Group to office",
    "finish-setting-up-your-account": "Finish setting up your account",
    "filter-by-office": "Filter Teams and work groups by Office",
    "save-whereabouts": "Save whereabouts",
    "clear-day": "Clear day",
    "add-holiday-request": "Add a leave request",
    "add-holiday": "Add Leave",
    "am": "AM",
    "pm": "PM",
    "all-day": "All day",
    "book-holiday": "Request holiday",
    "delete-holiday-request": "Delete holiday request",
    "book-am": "Book AM",
    "book-pm": "Book PM",
    "book-all-day": "Book all day",
    "am-only": "AM only",
    "pm-only": "PM only",
    "login-to-your-account": "Log in to your account",
    "continue-to-signup": "Continue to sign up",
    "user-view": "User view",
    "tag-manager": "Workgroup manager",
    "edit-and-manage-team": "Edit and manage team",
    "edit-and-manage-workgroup": "Edit and manage workgroup",
    "edit-and-manage-department": "Edit and manage department",
    "add-another-team": "Add another team",
    "add-another-team-member": "Add another team member",
    "set-up-company-and-add-teams": "Set up company and add teams",
    "add-new-favourite": "Add new favourite",
    "logout": "Logout",
    "move-another-user": "Add another team member",
    "done-for-now": "Done for now",
    "add-to-team": "Add to team",
    "approve": "Approve",
    "decline": "Decline",
    "approved": "Approved",
    "declined": "Declined",
    "pending": "Pending",
    "add-new-tag": "Add new workgroup",
    "edit-tags": "Edit workgroups",
    "setup-multiple-offices": "Set up multiple offices",
    "delete-office": "Delete office",
    "add-new-desk": "Add new desk",
    "add-new-area": "Add new area",
    "send-invite": "Send invite",
    "add-team-member": "Add team member",
    "delete-team": "Delete Team?",
    "download-csv": "Download .csv",
    "download-excel": "Export to Excel",
    "send-reminder": "Send reminder",
    "retry": "Retry",
    "go-back": "Go back",
    "finish-and-save": "Finish and save",
    "add-members": "Add members",
    "close": "Close",
    "add-team-members": "Add team members",
    "add-later": "I'll do this later",
    "upgrade": "Upgrade my account",
    "create": "Create",
    "checkout": "Checkout",
    "monthly": "Monthly",
    "yearly": "Yearly",
    "confirm": "Confirm",
    "save": "Save",
    "confirm-delete-team": "Yes, delete team",
    "reject-delete-team": "No don't remove team",
    "create-company": "Create company",
    "setup-more-teams": "Setup some other teams",
    "ok": "OK",
    "fetch-users-from-microsoft": "Fetch users from microsoft",
    "add-company-holiday": "Add a company holiday",
    "got-it": "Got it",
    "confirm-delete-user": "Yes, delete user",
    "reject-delete-user": "No don't remove user",
    "lets-go": "Lets go",
    "create-office": "Create office",
    "EDIT": "EDIT",
    "add-another-holiday": "Add another holiday",
    "upgrade-my-account": "Upgrade my account",
    "view-report": "View report",
    "yes-delete": "Yes, delete.",
    "cancel": "Cancel",
    "delete-user": "Delete user",
    "change": "Change",
    "edit-office": "Edit office",
    "create-new-office": "Create new office",
    "add-bookable-area": "Add a bookable area",
    "add-new-line-report": "Add new line report",
    "assign-users-to-team": "Assign users to teams",
    "full": "Full",
    "free": "Free",
    "partial": "Partial",
    "not-available": "Not available",
    "oof": "Out of office",
    "working-elsewhere": "Working elsewhere",
    "delete": "Delete",
    "save-company-holiday": "Save company holiday",
    "delete-holiday": "Delete holiday",
    "delete-account": "Remove all teams and data",
    "book": "Book",
    "view": "View",
    "delete-event-project": "Delete event",
    "view-subscription": "Manage Payment Method",
    "create-subscription": "Create a subscription",
    "try-again": "Try again",
    "day-view": "Day view",
    "week-view": "Week view",
    "month-view": "Month view",
    "year-view": "Year view",
    "download-office-attendees": "Download office report (.xls)",
    "download-car-park-attendees": "Download car park report (.xls)",
    "team-report": "Team report",
    "workgroup-report": "Workgroup report",
    "department-report": "Department report",
    "user-report": "User report",
    "create-team": "Create team",
    "turn-on-in-settings": "Turn on in settings",
    "log-in": "Log in",
    "today": "Today"
  },
  "loading": {
    "saving-whereabouts": "Saving whereabouts"
  },
  "View floor plan": "View floor plan",
  "dates": {
    "this-week": "This week"
  },
  "checkbox": {
    "first-aider": "First aider",
    "fire-warden": "Fire warden",
    "mental-first-aider": "Mental Health First aider",
    "key-holder": "Key holder"
  },
  "whereaboutsAvailability": {
    "show-avail-calendar-like": "Show availability on calendar as:",
    "show-as-free": "This will show as <strong>Free</strong> in your calendar.",
    "show-as-tentative": "This will show as <strong>Tentative</strong> in your calendar.",
    "show-as-busy": "This will show as <strong>Busy</strong> in your calendar.",
    "show-as-oof": "This will show as <strong>Out of Office</strong> in your calendar (Outlook only).",
    "show-as-working-elsewhere": "This will show as <strong>Working elsewhere</strong> in your calendar (Outlook only)."
  },
  "company-settings-page": {
    "whereabouts-management-tab": "Whereabouts management",
    "visitors-tab": "Visitors",
    "edit-company": "Edit company",
    "company-settings": "Company settings",
    "company-preferences": "Company Preferences",
    "edit-global": "Edit global settings",
    "signup-and-register": "Sign Up and Register Settings",
    "azure-and-active-dir-settings": "Azure and Active Directory Settings",
    "other": "Other Settings",
    "notifications": "Notification Settings",
    "tenant-id": "Azure Tenant ID",
    "general": "General",
    "danger-zone": "Danger Zone",
    "notifications-tab": "Notifications",
    "signup-and-register-tab": "Sign Up and Register",
    "azure-configuration": "Azure configuration",
    "other-tab": "Other",
    "automated-reporting-tab": "Automated Reporting",
    "waypoint-screens-tab": "Waypoint screens",
    "automated-reporting": {
      "description": "Configure scheduled reports that are automatically emailed to your team."
    },
    "api-keys-tab": "API Keys",
    "api-keys": {
      "public-api": {
        "title": "Public API key",
        "description": "Used by external integrations calling the Team Today public API."
      },
      "scim": {
        "title": "SCIM API key",
        "description": "Used by SCIM clients to provision and sync users."
      },
      "no-key": "No key generated yet.",
      "label": "Label",
      "label-placeholder": "e.g. Okta production",
      "unlabeled": "Unlabeled",
      "edit-label": "Edit label",
      "save-label": "Save",
      "cancel": "Cancel",
      "generate": "Generate key",
      "generate-additional": "Generate new key",
      "regenerate": "Regenerate",
      "revoke": "Revoke",
      "copy": "Copy",
      "copied": "Copied!",
      "confirm-regenerate": "This will invalidate the current key. Any integration using it will stop working. Continue?",
      "confirm-revoke": "This will delete the current key. Any integration using it will stop working. Continue?"
    }
  },
  "company-view-page": {
    "workgroups": "Workgroups",
    "choose-office-to-view": "Choose an office",
    "create-an-office": {
      "title": "Create an office",
      "description": "Set a limit to the number of office desks available so colleagues know when to come into the office."
    },
    "sidebar": {
      "create-work-group": "Create a work group?",
      "create-work-group-description": "Create work groups to allow users to exist in more than one team"
    },
    "all-teams": "All Teams",
    "work-groups": "Work Groups",
    "create-new-group": "Create a new group?",
    "create-new-department": "Create a new department?",
    "no-members-in-workgroup": "No work group members yet",
    "no-members-in-workgroup-description": "Work groups let users to exist in more than one team or department",
    "area-unavailable": "'Area - Unavailable'",
    "area": "Area:",
    "no-one-booked-in-area": "No one's booked into this area",
    "departments": "Departments"
  },
  "custom-whereabouts-page": {
    "whereabouts": "Whereabouts",
    "available-in-team-view": "Available in Team View, whereabouts enable your team plan to their working week.",
    "how-it-works": "How it works",
    "custom-whereabouts-requirements": "The following whereabouts are required by the system to function correctly but you can add further custom whereabouts below.",
    "promo-title": "Create and manage custom whereabouts",
    "promo-message": "Add custom Whereabouts to give your teams more options such as Offsite, Training, Illness and get detailed reporting in the reports section.",
    "enable-whereabouts-option": "Enable this whereabouts option",
    "day-notes-title": "Enable day notes",
    "day-notes-description": "Adds a free text field to the whereabouts option",
    "schengen-title": "Enable Schengen Tracking",
    "schengen-description": "This whereabouts will count towards a schengen day",
    "description": "Enable your team to plan their working week.",
    "default": "Default",
    "create-title": "Create custom whereabouts",
    "step-1-name": "1. Whereabouts name",
    "step-2-icon": "2. Choose an icon",
    "step-3-availability": "3. Show availability on Outlook or Google calendar as:",
    "final-setup": "Final set up",
    "option-list-title": "Give users a list of options to pick from",
    "option-list-description": "When a user selects this whereabouts they will be asked to pick from the list below",
    "option-list-upsell": "Option lists are available on the Premium and Enterprise plans.",
    "option-list-upsell-link": "Upgrade your plan",
    "option-list-not-enabled": "This feature is not enabled on your account. Contact",
    "option-list-add-option": "Add option",
    "option-list-free-text-title": "Allow free text",
    "option-list-free-text-description": "Users can also type their own answer instead of picking from the list",
    "delete-whereabouts": "Delete This Whereabouts"
  },
  "dialog": {
    "create-workgroup": "Create a workgroup",
    "add-new-team": "Add a new team",
    "add-people-to-team-message": "Ok lets add some people to this team",
    "max-teams-header-msteams": "You've run out of teams",
    "max-teams-header": "You've reached the maximum limit of teams",
    "max-teams-message-msteams": "You've reached the maximum limit of teams.",
    "max-teams-message": "You've used up your teams allowance, either delete some or upgrade your account.",
    "add-company-to-add-more-teams": "Add a company to add more teams",
    "add-self-to-team": "Add yourself to team",
    "add-self-to-team-warning": "This will update the current team you're in.",
    "selected-number-of-users-to-report-to-a-user": "You have selected {{userCount}} people that report to this person.",
    "week-notes": "Week notes",
    "no-week-notes": "No notes set for the team",
    "week-note-request-not-made": "Request has not been made yet",
    "week-notes-not-in-a-team": "You are not in a team. You can only set a note when you are in a team.",
    "add-note": "Add note",
    "week-note-last-updated": "Updated {{lastUpdated}}",
    "saved-whereabouts-errors-title": "Important: unable to save some of your future desk bookings",
    "saved-whereabouts-errors-content-1": "Your company's office booking policy limits future bookings for {{officeName}} to {{weeksAhead}} weeks ahead.",
    "saved-whereabouts-errors-content-2": "Currently, you can only book {{officeName}} up to the week ending {{weekEnding}}.",
    "saved-whereabouts-errors-content-2-fallback": "Currently, you can cannot book whereabouts that fair in advance.",
    "parking-whereabouts-errors-title": "Parking unavilable on some days",
    "parking-whereabouts-errors-date": "No parking space available on {{date}}",
    "general-whereabouts-errors-title": "",
    "unable-to-book-desks-far-in-advance-title": "Unable to Book Desks too Far in Advance",
    "unable-to-book-desks-far-in-advance-para1": "Your company's office booking policy limits future bookings for the {{officeName}} office to {{bookingWindow}} weeks ahead.",
    "unable-to-book-desks-far-in-advance-para2": "Currently, you can only book the {{officeName}} office up to the week commencing {{weekCommencing}}.",
    "unable-to-book-desks-far-in-advance-days_one": "Your company's office booking policy limits future bookings for the {{officeName}} office to {{count}} day ahead.",
    "unable-to-book-desks-far-in-advance-days_other": "Your company's office booking policy limits future bookings for the {{officeName}} office to {{count}} days ahead.",
    "unable-to-book-desks-far-in-advance-workdays_one": "Your company's office booking policy limits future bookings for the {{officeName}} office to {{count}} working day ahead.",
    "unable-to-book-desks-far-in-advance-workdays_other": "Your company's office booking policy limits future bookings for the {{officeName}} office to {{count}} working days ahead.",
    "unable-to-book-desks-far-in-advance-up-to": "Currently, you can only book the {{officeName}} office up to {{lastDate}}.",
    "unable-to-book-desks-far-in-advance-up-to-opens": "Currently, you can only book the {{officeName}} office up to {{lastDate}}. More dates open on {{opensAt}}.",
    "cannot-edit-approved-holiday-title": "Can't Edit Approved Holiday",
    "cannot-edit-approved-holiday-para1": "To cancel a holiday booking:",
    "cannot-edit-approved-holiday-list1": "Go to the Leave Planner",
    "cannot-edit-approved-holiday-list2": "Go to the Holidays Tab",
    "cannot-edit-approved-holiday-list3": "Tap the Edit Pencil on the holiday you wish to cancel",
    "cannot-edit-approved-holiday-list4": "Delete Holiday request",
    "cannot-edit-approved-holiday-para2": "This will cancel the holiday request.",
    "booked": "Booked",
    "unavailable": "Unavailable"
  },
  "approved-holiday-whereabouts-errors": {
    "title": "Can’t Edit Approved Holiday",
    "line1": "To cancel a holiday booking:",
    "line2": "Go to the <strong>Leave Planner</strong>",
    "line3": "Go to the <strong>Holidays Tab</strong>",
    "line4": "Tap the <strong>Edit Pencil</strong> on the holiday you wish to cancel",
    "line5": "<strong>Delete holiday request</strong>",
    "line6": "This will cancel the holiday request."
  },
  "add-multiple-users-dialog": {
    "title": "Add multiple users"
  },
  "usage-dialog": {},
  "side-of-day-dialog": {
    "title": "How Long Do you Require the Desk For?"
  },
  "day-notes-dialog": {
    "add-note": "Add note",
    "recent-notes": "Recent notes"
  },
  "whereabouts-option-picker-dialog": {
    "pick-option": "Pick an option",
    "or-free-text": "Or type your own",
    "skip": "Continue without picking"
  },
  "audit-logs-page": {
    "title": "Audit logs",
    "search": "Search",
    "search-placeholder": "Search by person or description",
    "category": "Category",
    "action": "Action",
    "source": "Source",
    "all-categories": "All categories",
    "all-actions": "All actions",
    "all-sources": "All sources",
    "showing": "Showing {{shown}} of {{total}} entries",
    "no-results": "No audit log entries match your filters.",
    "load-more": "Load more",
    "error": "Failed to load audit logs. Please try again.",
    "col-date": "Date",
    "col-action": "Action",
    "col-user": "User",
    "col-affected": "Affected user",
    "col-source": "Source",
    "col-description": "Description",
    "categories": {
      "HOLIDAYS": "Holidays & leave",
      "WHEREABOUTS": "Whereabouts",
      "USER_MANAGEMENT": "User management",
      "MEETING_ROOMS": "Meeting rooms",
      "COMPANY_SETTINGS": "Company settings",
      "SECURITY": "Security & API keys",
      "NOTIFICATIONS": "Notifications",
      "OFFICE_CHECK_IN": "Office check-in"
    },
    "sources": {
      "WEB": "Web",
      "SCIM": "SCIM",
      "SCHEDULER": "Scheduler",
      "PUBLIC_API": "Public API",
      "SYSTEM": "System"
    },
    "actions": {
      "BOOK_HOLIDAY": "Booked leave",
      "APPROVE_HOLIDAY": "Leave approved",
      "PENDING_HOLIDAY": "Leave request created",
      "REJECT_HOLIDAY": "Leave rejected",
      "CANCELLED_HOLIDAY_REQUEST": "Leave cancelled",
      "BOOK_CUSTOM_HOLIDAY": "Booked custom leave",
      "APPROVE_CUSTOM_HOLIDAY": "Custom leave approved",
      "PENDING_CUSTOM_HOLIDAY": "Custom leave request created",
      "REJECT_CUSTOM_HOLIDAY": "Custom leave rejected",
      "CANCELLED_CUSTOM_WHEREABOUTS_APPROVALS_REQUEST": "Custom whereabouts cancelled",
      "UPDATED_WHEREABOUTS": "Whereabouts updated",
      "UPDATE_USERS_HOLIDAY_ALLOWANCE": "Leave allowance updated",
      "PERFORM_ROLL_OVER": "Leave rollover performed",
      "CREATE_MEETING_ROOM": "Meeting room created",
      "DELETE_MEETING_ROOM": "Meeting room deleted",
      "CREATE_MEETING_ROOM_OUTLOOK_EVENT": "Outlook event created",
      "UPDATE_MEETING_ROOM_OUTLOOK_EVENT": "Outlook event updated",
      "CANCEL_MEETING_ROOM_BOOKING": "Meeting room booking cancelled",
      "CREATE_USER": "User created",
      "UPDATE_USER": "User updated",
      "DELETE_USER": "User deleted",
      "PERMANENTLY_DELETE_USER": "User permanently deleted",
      "RESTORE_USER": "User restored",
      "USER_REGISTERED": "User registered",
      "UPDATE_USER_PERMISSIONS": "Permissions changed",
      "CREATE_GROUP": "Group created",
      "UPDATE_GROUP": "Group updated",
      "DELETE_GROUP": "Group deleted",
      "PASSWORD_RESET_REQUESTED": "Password reset requested",
      "PASSWORD_RESET_COMPLETED": "Password reset completed",
      "GENERATE_API_KEY": "API key generated",
      "REVOKE_API_KEY": "API key revoked",
      "UPDATE_API_KEY_LABEL": "API key renamed",
      "UPDATE_PLATFORM_CONFIG": "Platform config updated",
      "UPDATE_COMPANY_SETTINGS": "Company settings updated",
      "UPDATE_TENANT_LINK": "Tenant link updated",
      "UPDATE_DOMAIN_SIGNUP": "Domain signup updated",
      "TEAMS_NOTIFICATION_SENT": "Teams notification sent",
      "AUTOMATIC_OFFICE_CHECK_IN": "Checked in automatically",
      "ADD_CHECKIN_IP_ADDRESS": "Office internet address requested",
      "REMOVE_CHECKIN_IP_ADDRESS": "Office internet address removed"
    }
  },
  "settings-page": {
    "title": "Settings",
    "manage-users": "Manage current users",
    "manage-users-1": "Edit, manage and add new users",
    "manage-users-2": "Change user permissions and default office",
    "manage-users-3": "Add key roles to users such as firewardens",
    "manage-teams": "Manage teams, workgroups and departments",
    "manage-teams-1": "Edit, manage and add new teams",
    "manage-teams-2": "View team members",
    "teams-tab": "Teams",
    "workgroups-tab": "Workgroups",
    "no-workgroups-message": "Users can be added to multiple workgroups to help group users across teams and departments.",
    "departments-tab": "Departments",
    "manage-departments": "Manage departments",
    "manage-departments-1": "Edit, manage and add new departments",
    "manage-departments-2": "View department members",
    "whereabouts": "Custom whereabouts",
    "whereabouts-1": "Choose additional whereabouts locations",
    "whereabouts-2": "Add multiple offsite locations",
    "reports": "Reports, data and audit logs",
    "report-1": "See reports on office usage",
    "report-2": "See reports on whereabouts and holidays",
    "report-3": "Download and export reports to excel",
    "office": "Offices and meeting rooms",
    "office-1": "Create and manage office locations, floor plans, and desks.",
    "office-2": "Configure meeting rooms and sync with Outlook.",
    "office-3": "Manage car parking and other bookable areas.",
    "holiday": "Leave settings",
    "holiday-1": "Turn on leave tracking and set up approvals",
    "holiday-2": "Change leave year start and end",
    "holiday-3": "Add national and company wide leave",
    "meeting-rooms": "Meeting Rooms",
    "meeting-rooms-1": "Create and edit bookable meeting rooms",
    "meeting-rooms-2": "Sync meeting rooms to Outlook Meeting rooms",
    "company": "Company settings",
    "company-1": "Control company wide settings ",
    "company-2": "Allow new users who reside in your company to log in",
    "company-3": "Change icon pack and set up repeat schedules",
    "personal": "Personal preferences",
    "personal-pref-1": "Manage calendar sync (Outlook and Gmail)",
    "personal-pref-2": "Manage favourites offices and desks",
    "personal-pref-3": "Enter car information for parking",
    "billing": "Billing and plan settings",
    "billing-1": "Increase or decrease your subscription",
    "billing-2": "View your invoices and receipts",
    "how-desk-capacities-work": "Enable desk booking if you would like to manage office capacities or split an office into floors and areas. If you'd like to include an interactive floor plan, simply send a reference diagram to <0>hello@team-today.com</0>.",
    "how-desk-capacities-work-title": "How it works",
    "edit-user": {
      "title": "Edit user",
      "email-address": "Email address",
      "member-of-team": "Member of team",
      "member-of-department": "Member of department",
      "member-of-workgroups": "Member of workgroups",
      "not-assigned-to-workgroups": "Not assigned to any workgroups",
      "location-title": "Location",
      "location-message": "Setting a default location makes choosing a desk quicker for colleagues. They can still pick any office to visit.",
      "office-base": "Office base",
      "standard-user": "Standard user",
      "basic-permissions": "Can only set their own whereabouts",
      "department-admin-permissions-1": "Full department management",
      "department-admin-permissions-2": "Is able to view and update all users within the department",
      "department-admin": "Department admin",
      "team-admin": "Team admin",
      "team-admin-permissions-1": "Full team management including adding and removing team members",
      "team-admin-permissions-2": "Can add new users and update users information",
      "team-admin-permissions-3": "Can make other users team admins",
      "office-admin": "Office admin",
      "office-admin-permissions-1": "Full office management of the users designated default office",
      "office-admin-permissions-2": "Can update office whereabouts of other users",
      "office-admin-permissions-3": "Access to office reporting",
      "office-admin-permissions-4": "Can make other users team admins",
      "company-admin": "Company Admin",
      "company-admin-permissions-1": "Full company management including creating and deleting teams",
      "company-admin-permissions-2": "Editing company details",
      "company-admin-permissions-3": "Add or remove users in any team",
      "permissions": "Permissions",
      "holiday-allowance": "Individual holiday allowance for the year",
      "holiday-allowance-message": "This overrides the default Company Leave allowance. This will be reset at the turn of the leave year back to the company default.",
      "users-allowance": "Set the holiday allowance for year",
      "for-year": "days for the year",
      "holiday-allowance-taken-from-users-setting": "The current leave allowance is taken from this User setting",
      "holiday-allowance-taken-from-company-setting": "The current leave allowance is taken from the Company settings",
      "holiday-allowance-not-yet-set": "The current leave allowance has not been set in the Company settings or in this User setting.",
      "additional-responsibilities": "Additional responsibilities",
      "additional-responsibilities-message": "Create Fire wardens and first aiders so you can easily see if there are any booked in to an office.",
      "access-permitted-title": "Access to Team Today",
      "access-permitted-description": "When disabled, the user will still exist in Team Today, but they will be unable to log in.",
      "birthday": {
        "title": "Share your birthday",
        "description": "Let others know when your birthday is coming up, this will display on the team view and work planner.",
        "month": "Month",
        "day": "Day"
      },
      "profile-tab": "Profile",
      "team-tab": "Team and groups",
      "office-tab": "Office",
      "access-tab": "Access and permissions",
      "leave-tab": "Leave",
      "responsibilities-tab": "Responsibilities",
      "teams-section": "Teams",
      "groups-section": "Groups",
      "delete-title": "Delete this user",
      "delete-description": "Deleting removes this user from Team Today and frees up their licence. You can restore them from <0>Deleted users</0> for 30 days. After that, they and all of their data are deleted permanently.",
      "delete-alternative": "To stop someone signing in but keep their account and history, turn off Access to Team Today in <0>Access and permissions</0> instead.",
      "delete-admin-only": "Only company admins can delete users."
    }
  },
  "manage-users-page": {
    "title": "Manage users",
    "search": "Search for a user",
    "showing-users": "Showing {{skip}} - {{count}} of {{total}} users",
    "not-logged-in": "Not logged in",
    "resend-invite": "Resend invite",
    "account": "Account",
    "user-count": "{{count}} users",
    "free-spaces-count": "{{count}} spaces free",
    "add-multiple-users": "Add multiple users",
    "assign-to-office": "Assign to office",
    "assign-to-department": "Assign to department",
    "assign-to-team": "Assign to team",
    "manage-teams": "Manage teams",
    "manage-workgroups": "Manage workgroups",
    "export-users": "Export users",
    "assign-to-workgroup": "Assign to workgroup",
    "select-all": "Select all",
    "deleted-users": "Deleted users"
  },
  "deleted-users-page": {
    "title": "Deleted users",
    "description": "These users have been removed and no longer count towards your licence. Restore a user to bring them back, or delete them permanently. Users left here are automatically deleted permanently after 30 days.",
    "empty": "There are no deleted users.",
    "back-to-users": "Back to users",
    "col-name": "Name",
    "col-email": "Email",
    "col-team": "Team",
    "undelete": "Restore",
    "delete-permanently": "Delete",
    "confirm-permanent": "Permanently delete?",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "restored": "User restored",
    "restore-failed": "Failed to restore user",
    "deleted-permanently": "User permanently deleted",
    "permanent-delete-failed": "Failed to permanently delete user",
    "load-failed": "Failed to load deleted users"
  },
  "account-deleted-page": {
    "title": "Your account has been deleted",
    "description": "Your account is no longer active. Please contact your IT team if you think this is a mistake."
  },
  "holiday": {
    "holiday-year": "Leave year",
    "days-left": "Days left",
    "days-taken-or-booked": "Days taken or booked",
    "company-holiday": "Company leave",
    "holiday-booking": "Leave booking",
    "your-summary": "Summary",
    "your-bookings": "Bookings",
    "users-bookings": "{{firstName}}'s bookings",
    "holiday-booked": "Leave booked"
  },
  "company-holiday": {
    "title": "Company holiday",
    "description": "Company holidays will be added to everyone’s calendars and prevent any bookings into the office",
    "number-of-holidays": "Number of holidays"
  },
  "unsubscribe-page": {
    "unsubscribed-title": "Unsubscribed",
    "unsubscribed-message-1": "You have been unsubscribed from Team Today reminder emails.",
    "unsubscribed-message-2": "You can resubscribe by logging in and visiting the settings area.",
    "unsubscribed-failed-title": "Unsubscribed failed",
    "unsubscribed-failed-message": "There has been an error in unsubscribing you.",
    "unsubscribed-contact": "Email us at <0>hello@team-today.com</0> for help unsubscribing."
  },
  "reports-page": {
    "reporting": "Reporting",
    "office-usage-title": "Office usage",
    "office-usage-description": "See statistics and data on office usage",
    "wfh-title": "Working from home reports",
    "wfh-description": "Statistics and data on working from home",
    "whereabouts-title": "Whereabouts",
    "all-departments": "All departments",
    "all-workgroups": "All workgroups",
    "whereabouts-description": "Statistics and data on group whereabouts",
    "users-whereabouts-title": "Users whereabouts",
    "users-whereabouts-description": "Statistics and data on single users whereabouts",
    "unknown-title": "Unknown whereabouts",
    "unknown-description": "View users with no whereabouts set",
    "line-reports-title": "Line reports",
    "line-reports-description": "See who reports to who",
    "holiday-usage-title": "Holiday usage",
    "holiday-usage-description": "See how many days people have taken and have left",
    "checkin-title": "Email check-in",
    "checkin-description": "See who confirmed their office visit from the check-in email",
    "automatic-checkin-title": "Automatic office check-in",
    "automatic-checkin-description": "View automatic check-ins from network detection",
    "automatic-checkin-log-title": "Check-in log",
    "no-shows-title": "No-shows",
    "no-shows-description": "People booked into the office who didn't check in",
    "desk-utilization-title": "Desk Utilization",
    "desk-utilization-description": "See how desks are being used across your offices",
    "desk-utilization-download-description": "Download a CSV showing each desk's daily booking status (1 = full day, 0.5 = half day, 0 = unbooked) for the selected date range.",
    "desk-utilization-report-title": "Desk Utilization Report",
    "desk-utilization-office": "Office",
    "desk-utilization-no-data": "No data found",
    "desk-utilization-no-data-description": "Select an office and date range to view desk utilization.",
    "desk-utilization-total-desks": "Total Desks",
    "desk-utilization-total-bookings": "Total Bookings",
    "desk-utilization-days-in-range": "Days in Range",
    "desk-utilization-utilization": "Utilization",
    "desk-utilization-by-floor": "Utilization by Floor",
    "desk-utilization-by-office": "Utilization by Office",
    "desk-utilization-top-desks": "Bottom 10 Desks by Utilization",
    "desk-utilization-top-offices": "Bottom 10 Offices by Utilization",
    "desk-utilization-company-wide": "Company wide",
    "desk-utilization-floor-breakdown": "Floor Breakdown",
    "desk-utilization-floor": "Floor",
    "desk-utilization-desks": "Desks",
    "desk-utilization-bookings": "Bookings",
    "desk-utilization-days": "Days",
    "desk-utilization-download-title": "Download Desk Usage Report",
    "car-park-utilization-title": "Car Park Usage",
    "car-park-utilization-description": "See how car park spaces are being used across your offices",
    "audit-logs-title": "Audit logs",
    "audit-logs-description": "See who changed what across your company",
    "car-park-utilization-report-title": "Car Park Usage Report",
    "car-park-utilization-office": "Office",
    "car-park-utilization-no-data": "No data found",
    "car-park-utilization-no-data-description": "Select an office and date range to view car park utilization.",
    "car-park-utilization-total-capacity": "Total Capacity",
    "car-park-utilization-total-bookings": "Total Bookings",
    "car-park-utilization-days-in-range": "Days in Range",
    "car-park-utilization-utilization": "Utilization",
    "car-park-utilization-by-office": "Utilization by Office",
    "car-park-utilization-company-wide": "Company wide",
    "car-park-utilization-office-breakdown": "Office Breakdown",
    "car-park-utilization-capacity": "Capacity",
    "car-park-utilization-bookings": "Bookings",
    "car-park-utilization-days": "Days",
    "car-park-utilization-daily-breakdown": "Daily Breakdown",
    "car-park-utilization-daily-utilization": "Daily Utilization",
    "car-park-utilization-date": "Date",
    "car-park-utilization-bottom-spaces": "Bottom 10 Spaces by Utilization",
    "meeting-room-usage-title": "Meeting Room Usage",
    "meeting-room-usage-description": "See how meeting rooms are being used across your offices",
    "meeting-room-usage-report-title": "Meeting Room Usage Report",
    "meeting-room-usage-disclaimer": "This report only includes meeting rooms booked through Team Today. Meetings booked directly in Outlook room calendars are not included.",
    "meeting-room-usage-office": "Office",
    "meeting-room-usage-company-wide": "Company wide",
    "meeting-room-usage-no-data": "No meeting rooms found",
    "meeting-room-usage-no-data-description": "Select an office and date range to view meeting room usage. Only bookings made in Team Today are included.",
    "meeting-room-usage-rooms": "Rooms",
    "meeting-room-usage-total-bookings": "Total Bookings",
    "meeting-room-usage-hours-booked": "Hours Booked",
    "meeting-room-usage-utilization": "Utilization",
    "meeting-room-usage-daily-bookings": "Daily Bookings",
    "meeting-room-usage-by-room": "Utilization by Room",
    "meeting-room-usage-room-breakdown": "Room Breakdown",
    "meeting-room-usage-room": "Room",
    "meeting-room-usage-capacity": "Capacity",
    "meeting-room-usage-bookings": "Bookings",
    "meeting-room-usage-avg-booking": "Avg Booking",
    "user-report": "User report",
    "department-report": "Departments report",
    "user-breakdown-title": "User report",
    "user-breakdown-description": "Summary of a users whereabouts",
    "user-breakdown-select-user-title": "To continue",
    "user-breakdown-select-user-description": "Search for a user to view a summary of their whereabouts over a period of time.",
    "fire-booked-in": "Fire wardens booked in",
    "no-fire-booked-in": "No fire wardens in the office",
    "first-booked-in": "First aiders booked in",
    "no-first-booked-in": "No first aiders in the office",
    "weeks-office-usage": "This weeks office usage",
    "updated-hourly": "Updated hourly",
    "office-usage-report": "Office Report",
    "download-office-report": "Download Office Report",
    "download-report": "Download a report",
    "choose-an-office": "Choose an office",
    "no-data-found": "No data found for that selection",
    "select-office-from-past-two-years": "Please select an office and a past date within the last 2 years.",
    "create-a-report": "Create a report",
    "office-usage-confirmation": "Office usage vs. confirmation",
    "typical-office-usage": "Typical Office usage",
    "download-holiday-summary": "Download Holiday Report",
    "download-absence-summary": "Download Absence Report",
    "edit-holiday-allowance": "Edit Holiday Allowance",
    "office-usage": {
      "all": "All",
      "all-offices": "All offices",
      "office-occupancy": "Office Occupancy",
      "download-offices-btn": "Download Occupancy Report",
      "choose-office": "Choose an Office",
      "choose-group": "Choose Team, Workgroup or Dept.",
      "choose-floor": "Choose a Floor",
      "custom": "Enter custom date range",
      "exit-custom": "Exit custom date range",
      "download-btn": "Download Floor Report",
      "download-desk-usage-btn": "Download Desk Usage Report",
      "capacity": "{{capacity}}% Capacity",
      "occupancy": "Floor Occupancy",
      "deskUsage": "Desk Usage",
      "top10Desks": "10 Most Used Desks",
      "bottom10Desks": "10 Least Used Desks",
      "heat-map": {
        "view-btn": "View heat map",
        "professional-plan": "Professional plan",
        "title": "Office heat map",
        "description": "How full each floor was, as a share of its capacity. Choose a floor to see which of its desks, areas and meeting rooms were used.",
        "office": "Office",
        "view-label": "View",
        "show-label": "Show",
        "typical-week": "Typical week",
        "by-date": "By date",
        "average": "Average",
        "busiest": "Busiest",
        "full-day": "Full day",
        "am": "AM",
        "pm": "PM",
        "floor": "Floor",
        "capacity": "Capacity {{capacity}}",
        "average-occupancy": "Average occupancy",
        "busiest-day": "Busiest day",
        "quietest-day": "Quietest day",
        "busiest-half-day": "Busiest half day",
        "grid-title": "Occupancy by floor",
        "download-title": "Download occupancy",
        "download-description": "One row for each floor and day, with the number of people in each morning and afternoon against the floor's capacity.",
        "capacity-note": "Capacity is each floor's capacity today, so older dates can show over 100% if desks have been removed since.",
        "weeks-note": "Long date ranges show one column per week, with the daily average for that week.",
        "range-too-long": "Choose a date range of a year or less.",
        "load-failed": "The heat map could not be loaded. Please try again.",
        "no-floors-title": "This office has no floors",
        "no-floors-description": "The heat map compares the floors of an office. Add floors to this office to use it.",
        "upgrade-title": "The heat map is part of the Professional plan",
        "upgrade-description": "See which floors, days and desks are busiest across your offices.",
        "upgrade-link": "See plans",
        "upgrade-teams": "To turn it on, contact support@team-today.com.",
        "choose-floor": "Choose a floor in the grid to see its desks, areas and meeting rooms.",
        "no-plan": "This floor has no floor plan, so its desks, areas and meeting rooms are listed instead.",
        "nothing-on-floor": "There are no desks, areas or meeting rooms on this floor.",
        "desks": "Desks",
        "areas": "Areas",
        "meeting-rooms": "Meeting rooms",
        "floor-note": "Desks show days booked out of {{days}} working days. Areas show people in the area against its capacity. Meeting rooms show hours booked out of an 8-hour working day.",
        "legend-empty": "Nobody in",
        "legend-not-used": "Not used",
        "legend-over": "Over capacity",
        "legend-no-capacity": "No capacity set"
      }
    },
    "unknown-whereabouts": {
      "title": "Unknown whereabout",
      "note": "Note",
      "all-users-have-whereabouts-set": "All users in your selection have their whereabouts set.",
      "reminder-last-sent": "reminder last sent {{days}} days ago"
    },
    "whereabouts-report": {
      "title": "Whereabouts Report",
      "no-date": "No data found for that selection",
      "select-a-date": "Please select a date within the last 2 years.",
      "high-level-report": "High level report",
      "detailed-report": "Detailed report"
    },
    "holidays-report": {
      "days-used": "Days used",
      "allowance": "Allowance",
      "team-name": "Team name",
      "user": "User",
      "percentage": "%",
      "holiday-year": "Leave year: {{year}}",
      "high-level-report": "High level report .xls",
      "detailed-report": "Detailed report .xls",
      "report": "Download report",
      "office": "In the Office (Total)"
    },
    "key-responsib": {
      "title": "Fire and safety",
      "description": "report and data",
      "nothing-selected-title": "Nothing to view",
      "nothing-selected": "Please select an office to view assigned roles",
      "one-fire-warden": "One fire warden per",
      "one-first-aider": "One first aider per",
      "staff": "staff",
      "fire-warden": "Fire warden",
      "first-aider": "First aider",
      "office-capacity": "Office capacity: {{officeCapacity}}",
      "people-in-office": "People in office: {{peopleInOffice}}",
      "key-role-in-office": "Key role in office: {{keyRoleInOffice}}",
      "loading": "Fetching data, this might take a minute"
    },
    "visitors-title": "Visitors",
    "visitors-description": "List and export everyone booked in to visit by day, week or month",
    "visitors-report-title": "Visitors Report",
    "visitors-disclaimer": "Includes every visitor booked in through Team Today, whether or not they were checked in on the day.",
    "visitors-office": "Office",
    "visitors-company-wide": "Company wide",
    "visitors-period": "Period",
    "visitors-no-data": "No visitors found",
    "visitors-no-data-description": "There are no visitor bookings for this office in the selected period.",
    "visitors-total": "Visitors",
    "visitors-checked-in": "Checked in",
    "visitors-checked-out": "Checked out",
    "visitors-not-checked-in": "Not checked in",
    "visitors-daily-chart": "Visitors per day",
    "visitors-table-date": "Date",
    "visitors-table-due": "Due",
    "visitors-table-visitor": "Visitor",
    "visitors-table-company": "Company",
    "visitors-table-email": "Email",
    "visitors-table-host": "Host",
    "visitors-table-office": "Office",
    "visitors-table-status": "Status",
    "visitors-table-checked-in": "Checked in",
    "visitors-table-checked-out": "Checked out",
    "visitors-status-none": "Not checked in",
    "visitors-status-checked-in": "Checked in",
    "visitors-status-checked-out": "Checked out",
    "visitors-download-title": "Download Visitors Report",
    "visitors-download-description": "Download a CSV with one row per visitor booking in the selected period, including host, office, due time and check-in and check-out times."
  },
  "holidays": {
    "company-holidays-applies-to": "Choose offices to apply this to:",
    "edit-holiday-title": "Edit leave",
    "add-holiday-title": "Add leave",
    "holidays": "My Leave",
    "holidays-disabled": "Holiday management not currently enabled",
    "holidays-disable-how-to-enable": "To enable holiday management including approvals simply turn on in the settings area.",
    "holiday-duration": "{{duration}} days",
    "add-new-leave": "Add New Leave",
    "add-leave": "Add Leave",
    "for-me": "For myself",
    "for-another": "For another team member",
    "holiday-year-span": "Leave Year {{from}} - {{to}}",
    "booked": "Leave Booked",
    "add-more-leave": "Add More Leave",
    "leave-reporting": "Leave Reporting",
    "days-booked": "Days booked",
    "days-left": "Days left",
    "view-holidays": "View Holidays",
    "allowance": "Allowance: {{number}} days",
    "carried-over": "Carried over: {{number}} days",
    "insufficient-access-title": "Admin Access Required",
    "insufficient-access-description": "To access data and reports please contact your manager or admin to request the necessary permissions.",
    "holiday-tracking-disabled-title": "Leave Reporting Inactive",
    "holiday-tracking-disabled-description": "You can turn on leave reporting for managers in the main settings area.",
    "leave-planner-disabled-title": "Leave Planner Inactive",
    "leave-planner-disabled-description": "You can turn on leave tracking in the main settings area."
  },
  "upgrade": "Upgrade",
  "change-pricing-plan": "Change your pricing plan",
  "get-in-touch": "Get in touch",
  "company": "Company",
  "help": "Help",
  "faqs": "FAQs",
  "copyright": "Copyright © 2026 Team Today. All rights reserved.",
  "create-new-team": "Create a new team?",
  "user-view": "User view",
  "User": "User",
  "Email": "Email",
  "Team name": "Team name",
  "Permissions": "Permissions",
  "tag-manager": "Workgroup manager",
  "Back": "Back",
  "back-to-company-view": "Back to company view",
  "users": "users",
  "team members": "team members",
  "members": "Members",
  "Add a team member": "Add a team member",
  "Invite a user": "Invite a user",
  "Add existing user": "Add existing user",
  "Select a team": "Select a team",
  "Search results": "Search results",
  "days": "days",
  "choose-office-to-view": "Choose an office to view",
  "create-an-office": "Create an office",
  "create-an-office-description": "Set a limit to the number of office desks available so colleagues know when to come into the office.",
  "office-space-bookings": "Office space bookings",
  "office-space-no-bookings": "No bookings",
  "open-office": "Open office",
  "select-team-to-add-user-to": "Select team to add to",
  "team-admins-limitation": "Team admins can only move users to their own team",
  "search-for-existing-user": "Search for an existing user",
  "tag-view": "Tag view",
  "Select...": "Select...",
  "did-you-know": "Did you know?",
  "desk-reservation": "Desk reservation",
  "desk": "Desk",
  "added-to-favourites": "Added to your favourites",
  "add-to-your-favourites": "Add to your favourites",
  "favouring-an-office-tip": "Favouring an office makes it quicker to select when setting your whereabouts for the week.",
  "back-to-whereabouts": "Back to whereabouts",
  "404-error": "Sorry, 404. Not Found",
  "admin-access-required": "Admin access required",
  "insufficient-rights": "Insufficient access right",
  "onboarding": {
    "add-user": {
      "title": "Add a team member",
      "message": "Add upto 10 people to this team"
    },
    "create-an-office": "Create an office",
    "create-team": "Lets create your first team for your company...",
    "create-team-description": "You can create as many teams as you like later",
    "welcome-for-company": "Welcome to the Team Today account for",
    "welcome": "Welcome to Team Today",
    "welcome-message": "Plan your whereabouts for the working week, book desks, manage office space and sync it all to your work calendars.",
    "welcome-to-existing-company": "Get started by simply setting your whereabouts for the next week. This’ll let the rest of your team know your plans... its a simple as that.",
    "choose-features": "Choose your features",
    "choose-features-description": "You can have as few or as many as you wish. Settings can be changed at any point in the future.",
    "whereabouts-feature": "Whereabouts",
    "whereabouts-feature-description": "A simple interface which lets everyone know where everyone is each week.",
    "deskbooking-feature": "Desk Booking and Car Parking",
    "deskbooking-feature-description": "Keep track of office space and see how many desks are available. Even book parking space.",
    "holiday-management-feature": "Holiday management",
    "holiday-management-feature-description": "Add line managers and authorise holidays via Team Today.",
    "office-created-title": "Office created",
    "office-created-message": "You can visit settings later to create multiple offices, floors, areas and add an interactive floor plan for colleagues to book in to.",
    "team-required": "team required",
    "create-office-reasoning": "You can create multiple offices for team members to visit.",
    "holiday-management": "Holiday management",
    "holiday-management-description": "Let team members keep track of days remaining and share with the wider team.",
    "holiday-management-default-number": "Default number of holidays",
    "holiday-management-tip": "You can set individual holiday allowances and set a renewal date in settings",
    "custom-whereabouts-title": "Create custom whereabouts and work locations easily",
    "custom-whereabouts-description": "Visit the settings / management area in Team Today to create custom Whereabouts such as building site, training or client visit and automatically sync them to your email calendars.",
    "icons-title": "Choose Your Icon Style",
    "icons-description": "Choose the style that best suits your company",
    "icons-detailed": "Detailed icons",
    "icons-simple": "Simple icons",
    "onboarding-complete": "All set up...",
    "onboarding-complete-description": "Don’t forget you can download the Team Today app from the Microsoft Teams store and log in.",
    "add-to-ms-teams": "Add to Microsoft Teams",
    "required": "REQUIRED"
  },
  "dialog-headers": {
    "sync-to-outlook": "For the best experience, sync Team Today to your Outlook calendar",
    "cannot-be-deleted": "That cannot be deleted",
    "are-you-sure": "Are you sure?",
    "update-desk": "Update desk",
    "edit-tags": "Edit workgroups",
    "add-group-member": "Add a group member",
    "manage-favourites": "Manage favourites",
    "filter-selection": "Filter selection",
    "whereabouts-have-been-edited": "Your whereabouts have been edited",
    "team-created": "Team created",
    "choose-area": "Choose an area",
    "choose-floor": "Choose a floor",
    "choose-office": "Choose an office",
    "add-custom-whereabouts": "Add custom whereabouts",
    "company-created": "Company created",
    "payment-failed": "Payment failed",
    "payment-successful": "Payment successful",
    "select-line-reports": "Select line reports",
    "follow-teams-and-workgroups": "Follow teams & workgroups"
  },
  "follow-dialog": {
    "description": "Select the teams and workgroups you'd like to follow. You can follow up to 3 teams and 3 workgroups.",
    "members": "members"
  },
  "payments": {
    "users-available-message": "You can add {{remainingUsers}} more team mates to this account.",
    "upgrade-account-in-settings": "Upgrade your account in settings",
    "with-as-many-users": "With a paid account you can add as many users as you like.",
    "how-many-users-you-need": "How many users do you need?",
    "manage-total-users": "Manage total users",
    "payment-method": "Payment method",
    "card-payment": "Card Payment",
    "bank-transfer": "Bank Transfer",
    "bank-transfer-contact": "To manage your plan via bank transfer contact <0>hello@team-today.com</0> with your company details",
    "bank-transfer-annual-only": "Annual plans only",
    "bank-transfer-currencies": "For bank transfer we can only accept GBP and Euro only",
    "bank-transfer-po": "We accept PO",
    "how-often-you-pay": "Payment frequency",
    "currency": "Currency",
    "first-10-users": "First 10 users",
    "FREE": "FREE",
    "total-paid-users": "Total paid users",
    "monthly-amount": "Monthly amount payable",
    "year-amount": "Yearly amount payable",
    "looking-to-cancel": "Looking to cancel?",
    "looking-to-cancel-message": "We’d hate to see you go but you can cancel your subscription at any time by emailing <0>hello@team-today.com</0>",
    "free-trial-ends": "Free trial ends",
    "view-payment-plan": "View your payment plan",
    "choose-plan": "Choose your plan",
    "standard": "Standard",
    "free-plan": "Free Plan",
    "professional-plan": "Professional Plan",
    "premium-plan": "Premium Plan",
    "enterprise-plan": "Enterprise Plan",
    "professional": "Professional",
    "premium": "Premium",
    "enterprise": "Enterprise",
    "professional-features": "Up to 6 custom whereabouts",
    "premium-features": "Visitor booking and up to 32 custom whereabouts",
    "enterprise-features": "Dedicated account manager and onboarding support",
    "your-plan": "Manage your plan",
    "manage-subscription": "Update Subscription",
    "manage-subscription-title": "Your Subscription",
    "nav-your-plan": "Your Plan",
    "nav-invoices": "Invoices",
    "current-plan": "Current Plan",
    "looking-to-upgrade": "Looking to upgrade?",
    "contact-us": "Contact Us",
    "upgrade-plan": "Upgrade Plan",
    "upgrade-contact-title": "Upgrade or update your subscription",
    "manage-plan-title": "Manage your plan",
    "manage-plan-body": "To adjust your license count or change your subscription plan, please contact us at <0>hello@team-today.com</0>. We will update your account details and handle any pro-rata billing adjustments for you.",
    "enterprise-contact-body": "To upgrade to our Enterprise plan, please get in touch at <0>hello@team-today.com</0> to speak to an account manager.",
    "your-payment-plan": "Your payment plan",
    "plan-pill": "{{plan}} Plan",
    "monthly-plan": "Monthly Plan",
    "annual-plan": "Annual Plan",
    "total-licences": "Total licences: {{licences}}",
    "plan-cost-summary-monthly": "{{cost}} / month - Billed monthly",
    "plan-cost-summary-yearly": "{{cost}} / year - Billed annually",
    "next-renewal": "Next renewal: {{date}}",
    "custom-whereabouts-count": "{{number}} x Custom whereabouts",
    "unlock-more-premium": "unlock more with premium",
    "meeting-rooms-count": "{{number}} x Meeting rooms",
    "professional-custom-whereabouts": "32 x Custom whereabouts",
    "professional-meeting-rooms": "24 x Meeting rooms",
    "advanced-reporting": "Advanced reporting",
    "priority-support": "Priority support",
    "interactive-floor-plans": "Interactive floor plans",
    "car-parking": "Car parking",
    "free-trial": "Free Trial",
    "change-plan-hint": "Switching plans takes effect immediately; your next invoice is prorated.",
    "confirm-plan-change": "Change your subscription plan now? Your next invoice will be prorated.",
    "confirm-plan-change-title": "Change plan",
    "confirm-plan-change-button": "Confirm change",
    "plan-changed": "Your plan has been updated",
    "plan-change-failed": "We couldn't change your plan, please contact hello@team-today.com",
    "downgrade-contact-support": "To downgrade your plan, please contact <0>support@team-today.com</0>",
    "manage-seats": "Manage total licences",
    "seats-in-use": "{{used}} of {{total}} paid user spaces in use",
    "licences-in-use": "{{used}} of {{total}} licences currently in use",
    "price-per-licence": "Price per licence",
    "licences": "Licences",
    "total": "Total",
    "period-month": "month",
    "period-year": "year",
    "update-seats": "Update spaces",
    "seats-change-hint": "Changing your paid spaces takes effect immediately; your next invoice is prorated.",
    "seats-updated": "Your paid spaces have been updated",
    "seats-update-failed": "We couldn't update your paid spaces, please contact hello@team-today.com",
    "update-licenses": "Update subscription",
    "licenses-updated": "Your licenses have been updated",
    "licenses-update-failed": "We couldn't update your licenses, please contact hello@team-today.com",
    "past-invoices": "Past invoices",
    "view-invoice": "View",
    "no-invoices": "No past invoices yet",
    "invoices-load-failed": "We couldn't load your invoices right now",
    "invoice-date": "Date",
    "invoice-amount": "Amount",
    "invoice-status": "Status"
  },
  "team": {
    "empty-team-title": "No members in this team",
    "empty-team-description": "Don't worry you can add some people to it",
    "team-member-invited": "Team member invited",
    "add-more-users-message": "You can add more team mates now or later through the app",
    "add-more-users-message-with-limit": "You can add <0>{remainingUsers} more</0> team mates to your <1>free account</1>",
    "remaining-users": "{{remainingUsers}} more",
    "free-account": "free account",
    "paid-account-upsell": "With a paid account you can add as many users as you like. Set up a FREE 30 day trial by emailing: hello@team-today.com.",
    "upgrade-link": "Or upgrade your account in settings",
    "restricted-team-title": "This team is private",
    "restricted-team-description": "To get access to this team ask an administrator to add you to it."
  },
  "whereabouts": {
    "select-floor": "Select a floor",
    "select-floor-description": "Select a floor to view the office and book your desk.",
    "looking-after-multiple-teams": "Looking after multiple teams?",
    "create-company-view": "Create a company view to see all your teams in one place",
    "custom-whereabouts": "Custom whereabouts",
    "add-custom-whereabouts": "Add custom whereabouts",
    "whereabouts-set-for-this-week": "Whereabouts set for this week",
    "all-done": "All done",
    "available-areas": "Available areas",
    "available-desks": "Choose desk via drop down",
    "seats-available": "{{remaining}} seats available",
    "add-favourite": "Add favourite",
    "favouriting-suggestion-title": "Change office regularly?",
    "favouriting-suggestion-description": "Favouriting an office makes it quicker to select when setting your whereabouts for the week.",
    "no-offices": "No offices!",
    "no-offices-description": "Add one or more offices in settings to make full use of this feature.",
    "add-office-button": "Add office",
    "num-of-group-members": "{{count}} group members",
    "desks-available": "Desks available",
    "parking-available": "Parking available",
    "no-available": "No parking",
    "require-parking-space": "Require parking space",
    "require-weekly-schedule": "Repeat schedule",
    "parking": "Parking",
    "car-park-bookings": "Car park bookings",
    "car-park-capacity-and-usage": "{{spaces}} Spaces - {{bookings}} Bookings",
    "select-on-floor-plan": "Choose a desk on floor plan",
    "repeat-schedule": {
      "title": "Repeat weekly schedule",
      "alternate-weeks": "Alternate",
      "repeat-schedule-for": "Repeat every week for",
      "weeks": "weeks",
      "confirm-schedule": "Confirm schedule",
      "cancel": "Cancel",
      "close": "Close",
      "updating": "Updating your weeks. This might take a minute.",
      "cannot-be-done-setting-not-set": "This feature cannot be used. Ask a company admin to go to Company settings to configure the number of weeks you can set."
    }
  },
  "office-checkin-page": {
    "title": "Thanks",
    "confirmed": "That's been confirmed.",
    "login-message": "You can now login to view your or your colleagues' whereabouts."
  },
  "delete-team-dialog": {
    "title": "Delete team",
    "description": "Are you sure you want to delete this team?",
    "warning-message": "Users will still be able to login but won't be assigned to a team"
  },
  "sync-to-outlook-dialog": {
    "yes": "Yes, sync to Outlook",
    "no": "Maybe later",
    "message": "You can always set this up later by visiting settings and editing your personal preferences."
  },
  "whereabouts-changed-dialog": {
    "accept-message": "To accept the changes simply tap the accept changes button and sync them to your calendar.",
    "accept-with-no-outlook-sync-1": "To accept the changes simply tap the accept changes button.",
    "accept-with-no-outlook-sync-2": "You can sync them to your Microsoft 365 or Google account by enabling the option in Settings.",
    "accept-and-sync": "Accept changes and sync to calendar",
    "accept": "Accept changes"
  },
  "delete-desk-dialog": {
    "message": "Deleting office will delete the following:",
    "a-desk": "1 desk",
    "bookings": "{{count}} whereabouts booking(s)",
    "cannot-be-deleted": "That desk belongs to a floor that has a floor plan configured, please contact us at <a href=\"mailto:support@team-today.com\">support@team-today.com</a> if you want to delete it."
  },
  "delete-office-dialog": {
    "message": "Deleting office will delete the following:",
    "office": "{{count}} offices(s)",
    "floor": "{{count}} floor(s)",
    "area": "{{count}} area(s)",
    "desk": "{{count}} desk(s)",
    "favourites": "{{count}} favourites(s)",
    "cannot-be-deleted-message": "That office contains a floor, please contact us at <0 href=\"mailto:support@team-today.com\">support@team-today.com</0> if you want to delete it."
  },
  "delete-user-dialog": {
    "description": "Are you sure you want to delete this user? They will be removed and will no longer count towards your licence. You can restore them from the Deleted users page within 30 days, after which they are permanently deleted.",
    "title": "Warning",
    "delete-permanently": "Delete",
    "permanent-title": "Permanently delete user?",
    "permanent-description": "This will permanently delete this user and all of their data immediately. This cannot be undone.",
    "confirm-permanent": "Yes, permanently delete",
    "permanent-delete-failed": "User failed to be permanently deleted"
  },
  "calendar": {
    "mon": "M",
    "tue": "T",
    "wed": "W",
    "thur": "T",
    "fri": "F",
    "sat": "S",
    "sun": "S",
    "choose-week": "Choose a week to view"
  },
  "ms-ad-sync": {
    "read-all-message-1": "This feature requires different permissions, it will only be used on your computer and no sensitive information will be sent to our servers.",
    "read-all-message-2": "Click here to request permissions from Microsoft",
    "message-1": "Below is a list of all users in your Microsoft account but not in Team Today.",
    "message-2": "You can quickly scroll down and invite people that you want to have access to Team Today.",
    "message-3": "After inviting them you will have to add them to a team or they can add themselves to a team when they sign up."
  },
  "room-finder": {
    "title": "Room finder",
    "no-selection": "No meeting rooms added",
    "no-meeting-rooms-in-office": "No meeting rooms in this office",
    "no-meeting-bookings": "You have no meeting room bookings to display.",
    "navigation": {
      "room-finder": "Room finder",
      "bookings": "My bookings",
      "open-search-panel": "Show filters",
      "filters": "Filters"
    },
    "number-of-people": {
      "title": "Number of people",
      "any": "Any",
      "1to2": "1 - 2",
      "3to5": "3 - 5",
      "6to8": "6 - 8",
      "8orMore": "8+"
    },
    "facilities": {
      "title": "Facilities",
      "tv": "TV",
      "conference-call": "Conference call",
      "whiteboard": "Whiteboard",
      "charge-points": "Charge points"
    },
    "floor-filter": {
      "title": "Floor",
      "all-floors": "All floors"
    }
  },
  "room-booking-dialog": {
    "add-to-calendar": "Add to calendar",
    "is-teams-meeting": "Teams meeting",
    "outlook-booked-meeting": "This meeting was booked through Outlook, you can update it here but changes may not be reflected in Outlook.",
    "notes": "Notes (set in Team Today)",
    "edit-booking-title": "Edit booking",
    "title": "Book meeting room",
    "meeting-title": "Enter meeting title",
    "confirm-booking": "Confirm booking",
    "update-booking": "Update booking",
    "cancel-booking": "Cancel booking",
    "cancel-series": "Cancel series",
    "apply-to-series": "Apply changes to all future meetings in this series",
    "save-changes": "Save changes",
    "no-booker-name": "Outlook booking",
    "cannot-book-outlook-room": "You cannot book this meeting room",
    "cannot-book-outlook-room-description": "First make sure your Calendar sync is active so we can reserve the room system wide.",
    "booked-in-outlook-title": "This meeting was booked via Outlook.",
    "booked-in-outlook-description": "To make changes to this booking please go to your Outlook calendar.",
    "outlook-link": "Outlook Link",
    "can-not-update-outlook-meeting": "Cannot update outlook meeting details",
    "recurrence": "Recurrence",
    "no-recurrence": "No recurrence",
    "daily": "Daily",
    "weekly": "Weekly",
    "fortnightly": "Fortnightly",
    "monthly": "Monthly",
    "yearly": "Yearly",
    "for": "For",
    "frequency-day": "day(s)",
    "frequency-week": "week(s)",
    "frequency-month": "month(s)",
    "frequency-year": "year(s)",
    "recurrence-summary": "Occurs {{frequency}} on {{dayName}}, ends on {{endDate}}.",
    "recurrence-summary-single": "Occurs {{frequency}} on {{dayName}}.",
    "recurrence-summary-monthly": "Occurs monthly on the {{dayOfMonth}}, ends on {{endDate}}.",
    "recurrence-summary-monthly-single": "Occurs monthly on the {{dayOfMonth}}.",
    "recurrence-summary-daily": "Occurs every weekday (Mon-Fri), ends on {{endDate}}.",
    "recurrence-summary-daily-single": "Occurs every weekday (Mon-Fri).",
    "recurrence-summary-fortnightly": "Occurs every two weeks on {{dayName}}, ends on {{endDate}}.",
    "recurrence-summary-fortnightly-single": "Occurs every two weeks on {{dayName}}.",
    "or-until": "Until"
  },
  "delete-meeting-room-dialog": {
    "delete-meeting-room": "Delete meeting room",
    "confirm-delete-meeting-room": "Yes, delete this meeting room",
    "capacity": "Approx. {{capacity}} people",
    "cancel": "No, keep this meeting room"
  },
  "reset-desks-dialog": {
    "reset-desks": "Reset selected desks",
    "reset-all-desks": "You are going to reset the allocation of {{count}} desks",
    "cancel": "Cancel"
  },
  "link-group-to-office-dialog": {
    "title": "Link team or workgroup to office",
    "office-label": "Select offices",
    "link-button": "Link offices",
    "clear-button": "Clear offices from groups"
  },
  "new-user-onboarding-dialog": {
    "title": "Welcome to Team Today",
    "done": "Done",
    "intro": "You can quick get yourself setup by completed these two steps.",
    "next": "Next",
    "office-label": "Select offices"
  },
  "manage-desks-sidebar": {
    "edit-view": "Edit view",
    "desk-allocation": "Desk Allocation",
    "edit-desk": "Edit desk",
    "desk-editor": "Desk Editor",
    "area-name": "Area name",
    "changed-desks-count": "{{count}} desk changed",
    "changed-desks-count_plural": "{{count}} desks changed",
    "save-desk-changes": "Save desk changes",
    "total-desks": "{{total}} Desks in total",
    "selected-desks": "{{selected}} Desks selected",
    "select-all-desks": "Select all desks",
    "assign-to-indi": "Assign to individual",
    "assign-to-team": "Assign to team",
    "assign-to-workgroup": "Assign to workgroup",
    "reset-desks": "Reset selected desks",
    "assign-desks-to-team": "Assign desks to team",
    "assign-desks-to-individual": "Assign desks to individual",
    "assign-desks-to-workgroup": "Assign desks to workgroup",
    "active": "Active"
  },
  "edit-team": {
    "select-office-description": "Select offices that this team is associated with",
    "select-departments-description": "Select departments that this team is associated with",
    "title": "Edit team",
    "team-name": "Team name"
  },
  "team-and-group-radio-button-list": {
    "filter-desks": "Filter desks by Teams and work groups",
    "show-all": "Show all"
  },
  "manage-tag-dialog": {
    "delete": "Delete workgroup",
    "update": "Update workgroup",
    "group-summary": "There are {{count}} users in this workgroup",
    "edit-title": "Edit a workgroup",
    "create-title": "Create a workgroup"
  },
  "manage": {
    "add-new-user": {
      "title": "Add a team member",
      "subtitle": "Invite up to {{count}} colleagues on this account",
      "invite-new-user": "Invite a new user",
      "add-existing-user": "Add an existing user",
      "required": "Required",
      "account": "Account",
      "free": "Free account",
      "premium": "Premium account",
      "trial": "Trial account",
      "enterprise": "Enterprise account",
      "total": "Total licenses",
      "current": "Current users",
      "remaining": "Spaces remaining",
      "team-member-added": "Team member added",
      "user-already-in-account": "This account already exists.\nGo to Settings > <0>Manage Users</0> to assign them to the correct team.",
      "user-deleted": "Account already exists.\nThis user was previously deleted. You can restore their access under Settings > Manage Users > <0>Deleted Users</0>.",
      "paid-account-promote": "With a paid account you can add as many users as you like. Set up a FREE 30 day trial by emailing: hello@team-Today.com",
      "upgrade": "Or upgrade your account in settings"
    }
  },
  "header": {
    "meeting-rooms": "Meeting Rooms",
    "leave-planner": "Leave Planner",
    "reports": "Reports",
    "view-my-bookings": "View My Bookings",
    "hospitality": "Hospitality"
  },
  "office-map": {
    "select-office": "Select an office"
  },
  "floor-plan-editor": {
    "open-editor": "Edit floor plan (Beta)",
    "add-desk": "Add desk",
    "add-area": "Add area",
    "save": "Save",
    "selected": "{{label}} selected",
    "rename-desk": "Rename desk",
    "clone-desk": "Clone desk",
    "keyboard-hint": "WASD to move, Q and E to rotate, C to clone",
    "delete-desk": "Delete desk",
    "desk-portrait": "Desk P ({{width}}, {{height}})",
    "desk-landscape": "Desk L ({{width}}, {{height}})",
    "corner-desk-portrait": "Corner desk P ({{width}}, {{height}})",
    "corner-desk-landscape": "Corner desk L ({{width}}, {{height}})",
    "rotate-left": "Rotate {{degrees}}° left",
    "rotate-right": "Rotate {{degrees}}° right",
    "new-area": "New area",
    "no-desks-warning": "You need to add at least one desk via the settings panel first",
    "unsaved-changes": "You have unsaved floor plan changes. Are you sure you want to leave?",
    "save-success": "Floor plan changes saved",
    "save-failed": "Failed to save floor plan changes",
    "area-create-failed": "Failed to create the area",
    "no-floor-plan": "This office doesn't have an interactive floor plan."
  },
  "desk-booking": {
    "confirm-booking": "Confirm Booking",
    "edit-parking": "Edit parking",
    "no-space-selected": "No space selected"
  },
  "car-parking": {
    "label": "Label",
    "yaxis": "Y axis",
    "width": "Width",
    "height": "Height",
    "rotation": "Rotation",
    "xaxis": "X axis",
    "edit-space-title": "Edit Parking Space",
    "cancel-booking": "Cancel booking",
    "am-cancel-booking": "Cancel AM",
    "pm-cancel-booking": "Cancel PM",
    "are-you-sure-delete": "Are you sure you want to delete this parking space?"
  },
  "lockers": {
    "title": "Lockers",
    "available": "Available",
    "assigned": "Assigned",
    "waiting-list": "Waiting list",
    "office": "Office",
    "select-office": "Select an office",
    "add-locker": "Add a locker",
    "bulk-add-help": "If you're adding lots of lockers, contact <0 href=\"mailto:hello@team-today.com\">hello@team-today.com</0> and we can do it in bulk for you.",
    "label": "Label",
    "label-placeholder": "e.g. B12",
    "location": "Office or floor",
    "select-location": "Select a location",
    "assign": "Assign",
    "release": "Release",
    "remove": "Remove",
    "assigned-on": "Assigned on",
    "joined-on": "Joined",
    "no-lockers-yet": "No lockers have been added yet.",
    "waiting-list-empty": "Nobody is waiting for a locker in this office.",
    "your-position": "Your position",
    "join-waiting-list": "Join waiting list",
    "leave-waiting-list": "Leave waiting list",
    "locker-count-at-office_one": "{{count}} locker at {{office}}",
    "locker-count-at-office_other": "{{count}} lockers at {{office}}",
    "free-count": "{{count}} free",
    "waiting-count": "{{count}} waiting",
    "people-waiting-at_one": "{{count}} person waiting at {{office}}",
    "people-waiting-at_other": "{{count}} people waiting at {{office}}",
    "waiting-days_one": "waiting {{count}} day",
    "waiting-days_other": "waiting {{count}} days",
    "none-free": "None free",
    "no-queue": "No queue",
    "of-total": "of {{count}}",
    "all-lockers": "All lockers",
    "locker": "Locker",
    "status": "Status",
    "assigned-to": "Assigned to",
    "actions": "Actions",
    "search-locker-or-person": "Search locker or person",
    "filter-all": "All",
    "filter-available": "Available",
    "filter-assigned": "Assigned",
    "clear-search": "Clear search",
    "no-lockers-at-office": "There are no lockers at this office yet.",
    "no-matching-lockers": "No lockers match your search.",
    "queue-clearing-summary": "{{free}} free right now, enough for {{assignments}} of the queue.",
    "other-offices": "Other offices",
    "confirm-delete": "Delete locker {{label}}? This cannot be undone.",
    "more-actions": "More actions",
    "member-subtitle-holder": "Your locker and what's free across the offices.",
    "member-subtitle-no-locker": "You don't have a locker at {{office}} yet.",
    "your-locker": "Your locker",
    "give-up-locker": "Give up my locker",
    "confirm-give-up": "Give up locker {{label}}? It goes back into the pool straight away.",
    "row-label": "Row {{row}}",
    "yours-since": "yours since {{date}}",
    "not-waiting-you-have-one": "You're not on any waiting list because you already have a locker at your office.",
    "position-in-queue": "{{position}} in the queue at {{office}}",
    "you-joined-on": "You joined on {{date}}",
    "waiting-in-total_one": "{{count}} person waiting in total",
    "waiting-in-total_other": "{{count}} people waiting in total",
    "another-office": "Another office?",
    "office-has-free_one": "{{office}} has {{count}} locker free.",
    "office-has-free_other": "{{office}} has {{count}} lockers free.",
    "join-office-list": "Join the {{office}} list",
    "no-locker-here": "You don't have a locker at {{office}}",
    "availability-by-office": "Availability by office",
    "numbers-only-note": "Numbers only, who holds what is admin-only",
    "join-from-any-office": "Join a list from any office you work in",
    "your-office": "Your office",
    "join-list": "Join list",
    "longest-wait_one": "longest wait {{count}} day",
    "longest-wait_other": "longest wait {{count}} days",
    "add-someone-to-list": "Add someone to the list",
    "free-right-now_one": "{{count}} locker is free right now",
    "free-right-now_other": "{{count}} lockers are free right now",
    "assigning-top-clears-to": "Assigning the top {{count}} would empty the queue down to {{name}}.",
    "assigning-top-clears-queue": "Assigning the top {{count}} would empty the queue.",
    "search-the-queue": "Search the queue",
    "sort": "Sort",
    "sort-queue-position": "Queue position",
    "sort-longest-waiting": "Longest waiting",
    "sort-name": "Name",
    "person": "Person",
    "team": "Team",
    "joined": "Joined",
    "waiting": "Waiting",
    "no-matching-people": "Nobody in the queue matches your search.",
    "assign-a-locker": "Assign a locker",
    "showing-all-waiting_one": "Showing {{count}} person waiting at {{office}}",
    "showing-all-waiting_other": "Showing all {{count}} people waiting at {{office}}",
    "average-wait_one": "Average wait {{count}} day",
    "average-wait_other": "Average wait {{count}} days",
    "queues-elsewhere": "Queues elsewhere",
    "no-other-offices": "No other offices have lockers.",
    "view-waiting-list": "View waiting list",
    "edit-locker": "Edit locker",
    "edit-label": "Edit label",
    "add-someone-help": "Search for the person you want to add to the waiting list at {{office}}."
  },
  "training": {
    "title": "Training",
    "people-tab": "People",
    "trainings-tab": "Trainings",
    "person": "Person",
    "training": "Training",
    "actions": "Actions",
    "log": "Log",
    "log-training": "Log training",
    "add-training": "Add a training",
    "edit-training": "Edit training",
    "all-people": "People tracked",
    "overdue": "Overdue",
    "expiring-soon": "Expiring in 3 months",
    "up-to-date": "Up to date",
    "completed": "Completed",
    "never-completed": "Never completed",
    "filter-all": "All",
    "filter-overdue": "Overdue",
    "filter-expiring-soon": "Expiring soon",
    "search-people": "Search people",
    "people-tracked_one": "{{count}} person tracked",
    "people-tracked_other": "{{count}} people tracked",
    "people-overdue": "{{count}} overdue",
    "people-expiring": "{{count}} expiring soon",
    "trainings-subtitle_one": "{{count}} training in the register",
    "trainings-subtitle_other": "{{count}} trainings in the register",
    "row-summary": "{{overdue}} overdue · {{expiring}} expiring soon",
    "type-row-summary": "{{completed}} done · {{overdue}} overdue · {{expiring}} expiring soon",
    "no-people": "Nobody has a training record yet. Log the first one to start the register.",
    "no-matching-people": "Nobody matches your search.",
    "no-trainings": "No trainings yet. Add one to start the register.",
    "name": "Name",
    "name-placeholder": "e.g. Fire Safety",
    "description": "Description (optional)",
    "description-placeholder": "What the training covers",
    "needs-repeating": "Needs repeating",
    "frequency": "Repeat every (days)",
    "frequency-hint": "How often it must be redone, in days.",
    "frequency-one-year": "1 year",
    "frequency-two-years": "2 years",
    "frequency-three-years": "3 years",
    "every-days": "Every {{count}} days",
    "one-off": "One-off",
    "select-training": "Select a training",
    "date-completed": "Date completed",
    "notes": "Notes (optional)",
    "notes-placeholder": "Provider, certificate number...",
    "confirm-delete": "Delete {{name}}? Everyone's records of it go too. This cannot be undone.",
    "my-training-title": "My Training",
    "my-training-description": "The training you've completed and when it needs doing again. Speak to your admin if something is missing.",
    "my-training-empty": "You have no training records yet.",
    "outstanding-heading": "Outstanding",
    "completed-heading": "Completed",
    "completed-date": "Completed {{date}}",
    "expires-date": "Expires {{date}}",
    "expired-date": "Expired {{date}}",
    "does-not-expire": "Does not expire"
  },
  "visitor-booking": {
    "daily-visitors": "Office Visitors",
    "filter": "Filter Visitors",
    "visitors-in-today": "{{count}} Visitors today",
    "manage-visitors": "Manage Visitors",
    "visitor-office-title": "Visitors - {{officeName}} office",
    "add-visitor": "Add a Visitor",
    "edit-visitor": "Edit a Visitor",
    "cancel": "Delete Visitor",
    "visitor-name": "Visitor name",
    "company-name": "Company name",
    "due-in": "Due in",
    "meeting-with": "Meeting with",
    "due-today": "Due today",
    "signed-in": "Signed in",
    "signed-out": "Signed out",
    "no-visitors-today": "No visitors today",
    "repeat-booking": "Repeat booking",
    "cancel-desk": "Cancel Desk",
    "book-desk": "Book Desk",
    "sign-in": "Sign In",
    "sign-out": "Sign Out",
    "meeting-room-label": "Meeting room: {{room}}",
    "meeting-room-label-with-time": "Meeting room: {{room}}, {{from}} to {{to}}"
  },
  "department-dialog": {
    "title": "Edit Department",
    "name": "Name",
    "users": "Number of users in department"
  },
  "allowance": {
    "expiry-report": "Holiday expiry report",
    "go-to-reporting": "Go to Reporting",
    "carry-over": "Carry over",
    "go-to-rollover-management": "Go to Holiday Rollover",
    "rollover": "Rollover",
    "confirm-dialog": {
      "title": "Are you sure?",
      "description-1": "This will perform holiday roll over for the entire company. It will roll over unused leave from {{previousYear}} into {{currentYear}}.",
      "description-2": "You will not be able to run company wide roll over again for this year.",
      "description-3": "You can update a single users roll over and other allowances via 'Edit individual holiday allowances'.",
      "continue": "Yes, roll over leave",
      "cancel": "No, i'm not ready yet"
    },
    "title": "Leave Allowance",
    "basic": "Basic Allowance",
    "just-additional": "Additional",
    "current-carryover": "Current carry over",
    "updated": "Updated",
    "projected-total": "Projected total for {{year}}",
    "unused-allowance": "Unused allowance from {{year}}",
    "days-to-carry-over": "Days to carry over into {{year}}`",
    "additional": "+ Additional Days",
    "carried-over": "+ Carried Over",
    "total": "Total",
    "used": "Used",
    "remaining": "Remaining",
    "remaining-days": "Remaining days",
    "standard-remaining-days": "Standard days remaining",
    "total-days-booked": "Total work days booked",
    "carry-over-remaining": "Carry over remaining",
    "justDays": "Days",
    "days": "{{days}} Days",
    "breakdown-basic": "Basic allowance",
    "breakdown-additional": "Additional days",
    "breakdown-carried-over": "Carried over from last year",
    "breakdown-expires": "Expires: {{date}}",
    "breakdown-total": "Total holiday allowance",
    "breakdown-total-expiry-tooltip": "Total allowance includes days that can expire",
    "holiday-carry-over-has-been-run": "Company wide auto roll over has already been run for this holiday year.<br>You can still edit peoples allowances individually or contact us to run the company wide roll over again.",
    "holiday-carry-over-info": {
      "info": "The holiday carry-over report shows a preview of next year’s carried-over days. Tap <strong>Confirm</strong> at the bottom of the screen to apply the updated allowances for all users.",
      "expiry-info": "The holiday expiry report shows a preview of days that are due to expire. Tap <strong>Confirm expiry</strong> at the bottom of the screen to apply the updated allowances for all users.",
      "carry-over-left": "The maximum carry-over limit is {{carryOverDays}} days.",
      "leave-settings": "To adjust this, go to <0>Leave settings</0>.",
      "carry-over-expires": "Carry-over expires on {{carryOverExpiryDate}}",
      "carry-over-does-not-expire": "Carry-over does not expire",
      "view-report": "View report",
      "carry-over-days-title-additional": "Includes {{additionalDays}} additional days.",
      "carry-over-days-title-carry": "Includes {{carriedOverDays}} carried over days.",
      "carry-over-days-explanation": "To adjust this, go to individual allowances",
      "days-to-carry-over-column-alert-title": "Currently set to carry over {{carryOverDays}} days.",
      "days-to-carry-over-column-alert-explanation": "If these numbers are different then leave has been been added since the carry over report was last run.",
      "carry-over-report-title": "Holiday carry over report"
    },
    "holiday-expiry-info": {
      "carry-over-left": "The maximum carry-over limit is {{carryOverDays}} days.",
      "leave-settings": "To adjust this, go to <0>Leave settings</0>.",
      "carry-over-expires": "Carry-over expires on {{carryOverExpiryDate}}",
      "carry-over-does-not-expire": "Carry-over does not expire",
      "view-report": "View report",
      "carry-over-days-title": "Includes {{additionalDays}} additional days.",
      "carry-over-days-explanation": "To adjust this, go to individual allowances"
    }
  },
  "leave-type-dialog": {
    "title": "Choose leave type"
  },
  "languages": {
    "english": "English",
    "french": "French",
    "german": "German",
    "spanish": "Spanish"
  },
  "calendar-sync": {
    "turn-on": "Turn on",
    "active": "Calendar sync active",
    "loading": "Calendar sync loading",
    "none": "No calendar sync",
    "disabled": "Calendar sync disabled",
    "unknown": "Status unknown"
  },
  "whereabouts-labels": {
    "COMPANY_HOLIDAY": "Company Holiday",
    "HOLIDAY_REJECTED": "Holiday (Rejected)",
    "HOLIDAY_APPROVED": "Holiday (Approved)",
    "NOT_WORKING": "Non working day",
    "UNKNOWN": "Unknown",
    "HOLIDAY": "Holiday",
    "HOLIDAY_PENDING": "Holiday (Pending)",
    "HOME": "Working from home",
    "OFFICE": "In the office"
  },
  "user-hover": {
    "add-favourites": "Add to Favourites",
    "remove-favourites": "Remove from Favourites",
    "leave": "View Leave"
  },
  "whereabouts-v2": {
    "team-view": "Team View",
    "day-view": "Day View",
    "week-view": "Week View",
    "month-view": "Month View",
    "day-short": "D",
    "week-short": "W",
    "month-short": "M",
    "filter-descriptor-office": "in the office",
    "filter-descriptor-working-elsewhere": "working elsewhere",
    "filter-descriptor-out-of-office": "out of office",
    "no-team-members-matching": "No team member {{descriptor}} this week",
    "no-team-members-matching-today": "No team member {{descriptor}} today",
    "show-all-team-members": "Show all",
    "calendar": "Calendar",
    "grid": "Grid",
    "today": "Today",
    "schengen-counts": "Schengen counts",
    "add-new-team-member": "Add New Team Member",
    "choose-teams-to-follow": "Choose Teams to Follow",
    "approvals-required": "Approvals Required",
    "add-project-or-event": "Add Project or Event",
    "my-whereabouts-report": "My Whereabouts Report",
    "view-parking": "View Parking",
    "profile-and-favourites": "Profile and Favourites",
    "no-groups-selected": "No teams or work groups selected",
    "group-not-found": "This team or work group could not be loaded",
    "restricted": "You don't have access to view this group",
    "my-whereabouts": "My Whereabouts",
    "filter-all": "All",
    "filter-working-elsewhere": "Working elsewhere",
    "filter-office": "Office",
    "filter-out-of-office": "Out of office",
    "office": "Office",
    "desk": "Desk",
    "parking": "Parking",
    "set-whereabouts": "Set whereabouts"
  },
  "hospitality": {
    "add-from-menu": "Add items from menu",
    "add-instructions": "Add instructions",
    "add-special-items": "Add special items",
    "confirm-instructions": "Confirm instructions",
    "instructions-title": "Add instructions",
    "instructions-description": "Add notes (e.g. dietary preferences)",
    "cost-center": "Cost centre",
    "choose-items": "Choose items from menu",
    "confirm": "Confirm choices",
    "add-item": "Add item",
    "special-hospitality-item-title": "Add special hospitality item",
    "food-cost": "Food cost (£)",
    "quantity": "Quantity",
    "delivery": "Delivery",
    "item": "Item",
    "total-cost": "Total cost",
    "no-items": "No items have been added to this meeting.",
    "not-started": "Not started",
    "in-progress": "In progress",
    "done": "Done",
    "report-day": "Download Day Report.csv",
    "report-week": "Download Week Report.csv",
    "report-month": "Download Month Report.csv",
    "no-bookings": "No hospitality bookings",
    "no-bookings-description": "Add hospitality when booking a meeting",
    "add-visitor": {
      "title": "Add visitor",
      "add-visitor": "Add visitor",
      "company": "Company name",
      "email": "Email address (only if sending meeting invite directly",
      "due-in": "Due in",
      "meeting-with": "Meeting with",
      "recent-visitors": "Recent visitors"
    }
  }
}
